(function () {
    'use strict';

    const {
      setScrollbarWidth
    } = window.PoleneLibs.Utils;
    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return dropdown$1; }), Promise.resolve().then(function () { return reveal$1; }), Promise.resolve().then(function () { return togglePreOrderBlock$1; }), Promise.resolve().then(function () { return main; }), Promise.resolve().then(function () { return componentCarousel$1; }), Promise.resolve().then(function () { return componentModal$1; }), Promise.resolve().then(function () { return componentProductCard$1; }), Promise.resolve().then(function () { return componentProductForm$1; }), Promise.resolve().then(function () { return countrySelectorModal$1; }), Promise.resolve().then(function () { return customerWishlist$1; }), Promise.resolve().then(function () { return bisForm$1; }), Promise.resolve().then(function () { return bisModal$1; }), Promise.resolve().then(function () { return eventForm$1; }), Promise.resolve().then(function () { return fragmentCartNotification$1; }), Promise.resolve().then(function () { return fragmentCursor$1; }), Promise.resolve().then(function () { return fragmentLineItemsList$1; }), Promise.resolve().then(function () { return fragmentNewsletterSignup$1; }), Promise.resolve().then(function () { return fragmentOptionSelect$1; }), Promise.resolve().then(function () { return fragmentRevealableItems$1; }), Promise.resolve().then(function () { return fragmentSearchTrigger$1; }), Promise.resolve().then(function () { return fragmentSubMenu$1; }), Promise.resolve().then(function () { return fragmentVideo$1; }), Promise.resolve().then(function () { return handleNewsletterEvent; }), Promise.resolve().then(function () { return imageLoaded$1; }), Promise.resolve().then(function () { return parallax$1; }), Promise.resolve().then(function () { return sectionAnnouncementBar$1; }), Promise.resolve().then(function () { return sectionArticleTeaser$1; }), Promise.resolve().then(function () { return sectionHeader$1; })];
        const componentsObj = hydrateComponents(components, setScrollbarWidth);
        await componentsObj.hydrate?.();
      })();
    });

    const {
      getRefs: getRefs$e,
      getElementsByRef: getElementsByRef$a
    } = window.PoleneLibs.Refs;
    const initDropdown = dropdown => {
      const ref = getRefs$e(dropdown);
      const KEYS = {
        SPACEBAR: [0, 32],
        ENTER: 13,
        DOWN_ARROW: 40,
        UP_ARROW: 38,
        ESCAPE: 27
      };
      if (!ref.items) return;
      if (dropdown.dataset.dropdown === 'store-selector') {
        const currentStore = ref.items.find(item => {
          const link = item.querySelector('a');
          return link?.href?.includes(location.hostname);
        });
        if (currentStore) {
          ref.selected.textContent = currentStore.textContent;
        }
      }
      ref.selected.addEventListener('click', e => toggleVisibility(e));
      ref.selected.addEventListener('keydown', e => toggleVisibility(e));
      document.body.addEventListener('click', e => handleBodyClick(e));
      const handleBodyClick = e => {
        const clickOutsideDropdown = !e.target.closest('[data-ref="dropdown"]');
        if (clickOutsideDropdown) close();
      };
      const handleClose = e => {
        setSelected(e);
        close();
      };
      const handleKeypress = e => {
        switch (e.keyCode) {
          case KEYS.ENTER:
            handleClose(e);
            return;
          case KEYS.DOWN_ARROW:
            focusNextItem(KEYS.DOWN_ARROW);
            return;
          case KEYS.UP_ARROW:
            focusNextItem(KEYS.UP_ARROW);
            return;
          case KEYS.ESCAPE:
            close();
            return;
          default:
            return;
        }
      };
      const itemTeardowns = ref.items.map(item => {
        item.addEventListener('click', handleClose);
        item.addEventListener('keydown', handleKeypress);
        return () => {
          item.removeEventListener('click', handleClose);
          item.removeEventListener('keydown', handleKeypress);
        };
      });
      function setSelected(e) {
        ref.selected.textContent = e.target.innerText;
      }
      function close() {
        ref.list.classList.remove('open');
        ref.container.setAttribute('aria-expanded', false);
        ref.container.hidden = true;
        ref.root.focus();
      }
      function toggleVisibility(e) {
        let openDropDown = KEYS.SPACEBAR.includes(e.keyCode) || e.keyCode === KEYS.ENTER;
        if (e.keyCode === KEYS.ESCAPE) close();
        if (e.type === 'click' || openDropDown) {
          ref.list.classList.toggle('open');
          ref.container.setAttribute('aria-expanded', ref.list.classList.contains('open'));
          ref.container.hidden = false;
        }
        if (e.keyCode === KEYS.DOWN_ARROW) {
          focusNextItem(KEYS.DOWN_ARROW);
        }
        if (e.keyCode === KEYS.UP_ARROW) {
          focusNextItem(KEYS.UP_ARROW);
        }
      }
      function focusNextItem(direction) {
        if (!ref.list.classList.contains('open')) {
          return;
        }
        const activeElement = document.activeElement;
        const activeElementId = activeElement instanceof HTMLElement ? activeElement.dataset?.id : undefined;
        if (activeElementId === 'selected') {
          ref.items[0].focus();
          return;
        }
        const activeItem = ref.items.findIndex(item => item.dataset.id === activeElementId);
        if (direction === KEYS.DOWN_ARROW) {
          const isLastItem = activeItem < ref.items.length - 1;
          if (isLastItem) {
            const nextListItemId = ref.items[activeItem + 1].dataset.id;
            ref.items.find(item => item.dataset.id === nextListItemId).focus();
          }
        }
        if (direction === KEYS.UP_ARROW) {
          const isFirstItem = activeItem > 0;
          if (isFirstItem) {
            const nextListItemId = ref.items[activeItem - 1].dataset.id;
            ref.items.find(item => item.dataset.id === nextListItemId).focus();
          }
        }
      }
      return () => {
        itemTeardowns.forEach(teardown => teardown());
      };
    };
    var dropdown = () => {
      const {
        dropdown
      } = getElementsByRef$a(['dropdown']);
      if (!dropdown) return;
      const elements = Array.isArray(dropdown) ? dropdown : [dropdown];
      const instances = elements.map(initDropdown);
      return () => {
        instances.forEach(teardown => teardown?.());
      };
    };

    var dropdown$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: dropdown
    });

    var reveal = () => {
      const {
        getElementsByRef
      } = window.PoleneLibs.Refs;
      const {
        revealElement
      } = getElementsByRef('reveal-element');
      if (!revealElement) return;
      const items = Array.isArray(revealElement) ? Array.from(revealElement) : [revealElement];
      const init = () => {
        items.forEach(item => item.classList.add('is-revealed'));
      };
      init();
    };

    var reveal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: reveal
    });

    var togglePreOrderBlock = window.addEventListener('PRODUCT_CARD_RENDERED', () => {
      const variantInPreorder = document.querySelectorAll('.variant-selector__variant.is-preorder');
      const disabledPreorder = document.querySelectorAll('.variant-selector__variant:not(.is-preorder)');
      if (variantInPreorder.length > 0) {
        variantInPreorder.forEach(variant => {
          const variantInformations = variant.dataset;
          const preorderInfoBlock = document.querySelector(`#preorder-${variantInformations.pid}`);
          if (preorderInfoBlock) {
            variant.addEventListener('mouseenter', function () {
              if ('pod' in variantInformations && variantInformations.pod && variantInformations.pod !== '' && 'pofd' in variantInformations && variantInformations.pofd && variantInformations.pofd !== '') {
                const preorderInput = variant.closest('.product-card')?.querySelector('input#pre-order');
                const preorderTagInput = variant.closest('.product-card')?.querySelector('input#pre-order-tag');
                const preorderDateInput = variant.closest('.product-card')?.querySelector('input#pre-order-date');
                updatePreOrderInfoBlock({
                  pofd: variantInformations.pofd,
                  preorderInfoBlock: preorderInfoBlock
                });
                if (preorderInput && preorderTagInput && preorderDateInput) {
                  [{
                    preorderInput: preorderInput,
                    name: `properties[${window.translations?.preorder}]`,
                    value: variantInformations.pofd
                  }, {
                    preorderInput: preorderTagInput,
                    name: `properties[_is_preorder]`,
                    value: 'true'
                  }, {
                    preorderInput: preorderDateInput,
                    name: `properties[_preorder_date]`,
                    value: variantInformations.pod
                  }].forEach(e => updatePreOrderInput(e));
                }
              } else {
                emptyPreorderInfoBlock({
                  preorderInfoBlock: preorderInfoBlock
                });
              }
            });
            variant.addEventListener('mouseleave', function () {
              emptyPreorderInfoBlock({
                preorderInfoBlock: preorderInfoBlock
              });
            });
          }
        });
      }
      if (disabledPreorder.length > 0) {
        disabledPreorder.forEach(variant => {
          const variantInformations = variant.dataset;
          const preorderInfoBlock = document.querySelector(`#preorder-${variantInformations.pid}`);
          variant.addEventListener('mouseover', function () {
            if (preorderInfoBlock) {
              const preorderInput = variant.closest('.product-card')?.querySelector('input#pre-order');
              const preorderTagInput = variant.closest('.product-card')?.querySelector('input#pre-order-tag');
              const preorderDateInput = variant.closest('.product-card')?.querySelector('input#pre-order-date');
              if (preorderInput && preorderTagInput && preorderDateInput) {
                [{
                  preorderInput: preorderInput,
                  name: '',
                  value: ''
                }, {
                  preorderInput: preorderTagInput,
                  name: '',
                  value: ''
                }, {
                  preorderInput: preorderDateInput,
                  name: '',
                  value: ''
                }].forEach(e => updatePreOrderInput(e));
              }
              emptyPreorderInfoBlock({
                preorderInfoBlock: preorderInfoBlock
              });
            }
          });
        });
      }
      window.addEventListener('TRIGGER_NOTIFICATION_LAYOUT', event => {
        const detail = event.detail;
        if (detail) {
          const preorderInput = detail.element.querySelector('input#pre-order');
          const preorderTag = detail.element.querySelector('input#pre-order-tag');
          const preorderDate = detail.element.querySelector('input#pre-order-date');
          const product_variants = detail.element.querySelectorAll('.variant-selector__variant');
          if (preorderInput && product_variants && preorderTag && preorderDate) {
            product_variants.forEach(variant => {
              variant.addEventListener('click', () => {
                if ('pofd' in variant.dataset && variant.dataset.pofd && variant.dataset.pofd !== '' && variant.dataset.pod) {
                  [{
                    preorderInput: preorderInput,
                    value: variant.dataset.pofd,
                    name: `properties[${window.translations?.preorder}]`
                  }, {
                    preorderInput: preorderTag,
                    value: 'true',
                    name: `properties[_is_preorder]`
                  }, {
                    preorderInput: preorderDate,
                    value: variant.dataset.pod,
                    name: `properties[_preorder_date]`
                  }].forEach(e => updatePreOrderInput(e));
                } else {
                  [{
                    preorderInput: preorderInput,
                    value: '',
                    name: ''
                  }, {
                    preorderInput: preorderTag,
                    value: '',
                    name: ''
                  }, {
                    preorderInput: preorderDate,
                    value: '',
                    name: ''
                  }].forEach(e => updatePreOrderInput(e));
                }
              });
            });
          }
        }
      });
      function emptyPreorderInfoBlock({
        preorderInfoBlock
      }) {
        preorderInfoBlock.innerHTML = '';
      }
      function updatePreOrderInfoBlock({
        pofd,
        preorderInfoBlock
      }) {
        emptyPreorderInfoBlock({
          preorderInfoBlock: preorderInfoBlock
        });
        preorderInfoBlock.innerHTML = `
			<span class="ts-label-s js-preorder-title">${window.translations?.preorder}</span>
			<span class="ts-label-s ts-grey js-preorder-info">${pofd}</span>
		`;
      }
      function updatePreOrderInput({
        preorderInput,
        value,
        name
      }) {
        preorderInput?.setAttribute('name', name);
        preorderInput?.setAttribute('value', value);
      }
      return () => {};
    });

    var togglePreOrderBlock$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: togglePreOrderBlock
    });

    class Accordion {
      static currentOpen = null;
      constructor(domNode, autoClose, autoSetHiddenAttribute) {
        this.autoClose = autoClose;
        this.autoSetHiddenAttribute = autoSetHiddenAttribute;
        this.rootEl = domNode;
        this.buttonEl = this.rootEl?.querySelector('button[aria-expanded]') ?? undefined;
        const controlsId = this.buttonEl?.getAttribute('aria-controls') ?? undefined;
        this.contentEl = controlsId ? document.getElementById(controlsId) : undefined;
        this.closeIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-close') : undefined;
        this.openIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-open') : undefined;
        this.open = this.buttonEl?.getAttribute('aria-expanded') === 'true';
        this.buttonEl?.addEventListener('click', this.onButtonClick.bind(this));
        if (this.open) {
          Accordion.currentOpen = this;
        }
      }
      onButtonClick() {
        if (!this.open && Accordion.currentOpen && this.autoClose) {
          Accordion.closeCurrentOpen();
        }
        this.toggle(!this.open);
      }
      toggle(open) {
        if (open === this.open) {
          return;
        }
        this.open = open;
        Accordion.currentOpen = open ? this : null;
        this.buttonEl?.setAttribute('aria-expanded', `${open}`);
        const grandParentNode = this.buttonEl?.parentNode?.parentNode;
        this.buttonEl?.setAttribute('aria-expanded', `${open}`);
        grandParentNode?.classList.toggle('active', open);
        if (open) {
          this.autoSetHiddenAttribute ? this.contentEl?.removeAttribute('hidden') : this.contentEl?.classList.remove('hidden');
          this.closeIconEl?.classList.remove('hidden');
          this.openIconEl?.classList.add('hidden');
        } else {
          this.autoSetHiddenAttribute ? this.contentEl?.setAttribute('hidden', '') : this.contentEl?.classList.add('hidden');
          this.closeIconEl?.classList.add('hidden');
          this.openIconEl?.classList.remove('hidden');
        }
      }
      static closeCurrentOpen() {
        if (Accordion.currentOpen) {
          Accordion.currentOpen.setClose();
        }
      }
      setOpen() {
        this.toggle(true);
      }
      setClose() {
        this.toggle(false);
      }
    }

    const AccordionModule = () => {
      window.addEventListener('DOMContentLoaded', () => {
        const accordionGroup = document.querySelectorAll('.accordion-group');
        accordionGroup.forEach(accordionGroupEl => {
          const autoClose = accordionGroupEl?.dataset.closeOthers === 'true';
          const autoSetHiddenAttribute = accordionGroupEl?.dataset.autoSetHiddenAttribute === 'true';
          const accordions = accordionGroupEl.querySelectorAll('.accordion');
          accordions.forEach(accordionEl => {
            new Accordion(accordionEl, autoClose, autoSetHiddenAttribute);
          });
        });
      });
    };

    var main = /*#__PURE__*/Object.freeze({
        __proto__: null,
        AccordionModule: AccordionModule,
        default: AccordionModule
    });

    const events$b = window.PoleneLibs.Events.default;
    const {
      intersection: intersection$1
    } = window.PoleneLibs.Observer;
    const {
      dispatchEvent: dispatchEvent$8
    } = window.PoleneLibs.Utils;
    const PhotoSwipeLightbox = window.PoleneVendors.PhotoSwipeLightbox;
    const {
      Autoplay,
      FreeMode,
      Mousewheel,
      Navigation,
      Pagination
    } = window.PoleneVendors.SwiperModules;
    const Swiper = window.PoleneVendors.Swiper;
    const {
      getElementsByRef: getElementsByRef$9,
      getRefs: getRefs$d
    } = window.PoleneLibs.Refs;
    const {
      close
    } = window.PoleneLibs.SvgTemplates;
    const autoPlay = (swiper, {
      speed
    }) => {
      const computedDirection = document.documentElement.getAttribute('dir') === 'rtl' ? 'ltr' : 'rtl';
      let running = true;
      let hovered = false;
      const onPointerEnter = () => hovered = true;
      const onPointerLeave = () => hovered = false;
      const normalizedSpeed = speed ? speed / 10 : 0.5;
      swiper.el.addEventListener('pointerenter', onPointerEnter);
      swiper.el.addEventListener('pointerleave', onPointerLeave);
      const tick = () => {
        if (running) requestAnimationFrame(tick);
        const dir = computedDirection !== 'rtl' ? 1 : -1;
        if (swiper.touchEventsData.isTouched || swiper.animating) return;
        if (hovered) return;
        swiper.setTransition(0);
        swiper.setTranslate(-swiper.translate * dir - normalizedSpeed);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (swiper.params.loop) {
          swiper.loopFix({
            direction: dir ? 'next' : 'prev',
            byMousewheel: true
          });
        }
      };
      tick();
      return {
        stop: () => {
          running = false;
        },
        start() {
          running = true;
          tick();
        },
        destroy: () => {
          swiper.el.removeEventListener('pointerenter', onPointerEnter);
          swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
      };
    };
    const makeVisibleSlidesFocusable = (slides, containerRect) => {
      let lastVisibleSlide = null;
      slides.forEach(slide => {
        const rect = slide.getBoundingClientRect();
        if (rect.left >= containerRect.left && rect.right <= containerRect.right + 20) {
          slide.setAttribute('tabindex', '0');
          slide.setAttribute('aria-hidden', 'false');
          lastVisibleSlide = slide;
        } else {
          slide.setAttribute('tabindex', '-1');
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      return lastVisibleSlide;
    };
    const manageFocus = swiper => {
      setTimeout(() => {
        const slides = Array.from(swiper.slides);
        const containerRect = swiper.$el[0].getBoundingClientRect();
        const lastVisibleSlide = makeVisibleSlidesFocusable(slides, containerRect);
        if (swiper.activeIndex > swiper.previousIndex) slides[swiper.activeIndex].focus();else if (lastVisibleSlide && swiper.activeIndex < swiper.previousIndex) lastVisibleSlide.focus();
      }, 500);
    };
    const classes$c = {
      peek: 'is-peeking'
    };
    const selectors$b = {
      activeSlide: '.swiper-slide-active',
      nextSlide: '.swiper-slide-next'
    };
    const configurations = {
      'ticker': {
        options: {
          autoplay: true
        },
        config: {
          speed: 0,
          breakpoints: {
            320: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            900: {
              slidesPerView: 7,
              spaceBetween: 30
            }
          },
          freeMode: {
            enabled: false,
            sticky: false,
            momentumRatio: 0.1,
            momentumVelocityRatio: 0.1
          }
        }
      },
      'triple': {
        options: {},
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          spaceBetween: 12,
          slidesPerView: 2,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          }
        }
      },
      'article-list': {
        options: {},
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          spaceBetween: 12,
          slidesPerView: 3,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          }
        }
      },
      'product-hero': {
        options: {},
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          spaceBetween: 0,
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          }
        }
      },
      'image-carousel': {
        options: {
          hasNextClick: true
        },
        config: {
          freeMode: {
            enabled: false,
            sticky: false
          },
          centeredSlides: false,
          loop: false
        }
      },
      'variant-selector': {
        options: {
          hasNextClick: false
        },
        config: {
          spaceBetween: 4,
          breakpoints: {
            600: {
              slidesPerView: 'auto',
              slidesPerGroup: 'auto'
            },
            1024: {
              slidesPerView: 6,
              slidesPerGroup: 6
            }
          },
          loop: false,
          centeredSlides: false,
          navigation: {
            nextEl: '.carousel__button-next',
            prevEl: '.carousel__button-prev'
          },
          on: {
            init: function (swiper) {
              swiper.initialized = false;
              const activeSlide = swiper.el.querySelector('.is-active');
              if (activeSlide) {
                const activeIndex = Array.from(swiper.slides).indexOf(activeSlide);
                if (activeIndex >= 6) {
                  swiper.slideTo(activeIndex, 0);
                }
                requestAnimationFrame(() => {
                  makeVisibleSlidesFocusable(Array.from(swiper.slides), swiper.$el[0].getBoundingClientRect());
                  setTimeout(() => {
                    swiper.initialized = true;
                  }, 100);
                });
              } else {
                swiper.initialized = true;
              }
            },
            slideChange: swiper => {
              if (swiper.initialized) {
                manageFocus(swiper);
              }
            }
          }
        }
      }
    };
    var componentCarousel = () => {
      const {
        carousel
      } = getElementsByRef$9('carousel');
      if (!carousel) {
        return;
      }
      if (!carousel) return;
      const carousels = Array.isArray(carousel) ? [...carousel] : [carousel];
      const swipers = carousels.map(carousel => {
        let swiper;
        let hasPeeked = false;
        let convention;
        let autoPlayer;
        let observer;
        const initSwiper = ({
          container,
          config,
          options,
          autoplaySpeed
        }) => {
          swiper = new Swiper(container, config);
          if (options.autoplay) autoPlayer = autoPlay(swiper, {
            speed: autoplaySpeed
          });
          if (swiper.slides.length > 2 && !!options.hasNextClick) {
            swiper.slides.forEach(slide => {
              slide.addEventListener('mouseenter', handleMouseEnter);
            });
          }
        };
        const handleMouseEnter = e => {
          if (!swiper) return;
          const next = e.target.closest(selectors$b.nextSlide);
          const active = e.target.closest(selectors$b.activeSlide);
          const isFirstItem = swiper.activeIndex === 0;
          const isLastItem = swiper.activeIndex === swiper.slides.length - 2;
          if (next && !isLastItem) {
            dispatchEvent$8(window, events$b.CHANGE_CURSOR, {
              type: 'next',
              contrast: true
            });
          } else if (active && !isFirstItem) {
            dispatchEvent$8(window, events$b.CHANGE_CURSOR, {
              type: 'prev',
              contrast: true
            });
          } else {
            dispatchEvent$8(window, events$b.CHANGE_CURSOR, {
              type: 'default',
              contrast: false
            });
          }
        };
        const handleNextClick = e => {
          if (!swiper) return;
          const next = e.target.closest(selectors$b.nextSlide);
          const active = e.target.closest(selectors$b.activeSlide);
          const firstItemClicked = swiper.clickedIndex === 0;
          const lastItemClicked = swiper.clickedIndex === swiper.slides.length - 1;
          if (next && !lastItemClicked) {
            swiper.slideNext();
          }
          if (active && !firstItemClicked) {
            swiper.slidePrev();
          }
        };
        const handleIntersection = ([entry]) => {
          if (!swiper) return;
          const peekIndex = swiper.activeIndex + 2;
          if (peekIndex > 3) return;
          const peekItem = swiper.slides[peekIndex];
          if (entry.isIntersecting && !hasPeeked) {
            peekItem.classList.add(classes$c.peek);
            hasPeeked = true;
          }
        };
        const resetCursor = () => {
          dispatchEvent$8(window, events$b.CHANGE_CURSOR, {
            type: 'default',
            contrast: false
          });
        };
        const removeAllEventListeners = () => {
          if (autoPlayer) autoPlayer.destroy();
          if (carousel) {
            carousel.removeEventListener('click', handleNextClick);
            carousel.removeEventListener('mouseleave', resetCursor);
          }
          if (swiper) swiper.slides.forEach(slide => {
            slide.removeEventListener('mouseenter', handleMouseEnter);
          });
          if (observer) observer.disconnect();
        };
        const {
          configType,
          configHorizontalScroll,
          configAutoplay,
          configAutoplaySpeed,
          configPagination
        } = carousel.dataset;
        if (!configType) return removeAllEventListeners;
        const options = configurations[configType].options;
        const {
          container
        } = getRefs$d(carousel);
        if (configAutoplay) {
          configurations[configType].options.autoplay = configAutoplay === 'true';
        }
        if (configPagination && configPagination === 'true') {
          configurations[configType].config.pagination = {
            el: '.swiper-pagination',
            type: 'bullets'
          };
        }
        convention = {
          modules: [Mousewheel, FreeMode, Autoplay, Pagination, Navigation],
          freeMode: {
            enabled: true,
            sticky: false
          },
          pagination: false,
          slidesPerView: 'auto',
          direction: 'horizontal',
          watchOverflow: true,
          loop: true,
          centeredSlides: true,
          allowTouchMove: configHorizontalScroll ? configHorizontalScroll === 'true' : true,
          mousewheel: {
            invert: false,
            forceToAxis: true,
            enabled: configHorizontalScroll ? configHorizontalScroll === 'true' : true
          },
          ...configurations[configType].config
        };
        initSwiper({
          container: container,
          config: convention,
          options: options,
          autoplaySpeed: parseFloat(configAutoplaySpeed ? configAutoplaySpeed : '0.5')
        });
        if (configType === 'product-hero') {
          if (!swiper?.slides.length) return removeAllEventListeners;
          const lightbox = new PhotoSwipeLightbox({
            closeSVG: close,
            bgOpacity: 1,
            gallery: carousel,
            children: swiper.slides,
            zoom: false,
            counter: false,
            initialZoomLevel: 'fill',
            secondaryZoomLevel: 1,
            maxZoomLevel: 2,
            pswpModule: window.PoleneVendors.PhotoSwipe
          });
          lightbox.init();
        }
        if (options.hasNextClick) {
          carousel.addEventListener('click', handleNextClick);
          carousel.addEventListener('mouseleave', resetCursor);
          if (!swiper || 'imagesToLoad' in swiper && Array.isArray(swiper.imagesToLoad) && swiper.imagesToLoad.length <= 2) return removeAllEventListeners;
          observer = intersection$1(carousel, handleIntersection, {
            threshold: [0.8]
          });
        }
        return removeAllEventListeners;
      });
      return () => {
        swipers.forEach(teardown => teardown());
      };
    };

    var componentCarousel$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentCarousel
    });

    const PROXY_BASE_PATH = '/apps/polene-theme-features';
    const KLAVIYO_BASE_PATH = 'https://a.klaviyo.com/client';
    const KLAVIYO_ID = window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const API_PROXY = {
      RETURNS: PROXY_BASE_PATH + '/order-returns',
      RETURN_BUTTON: PROXY_BASE_PATH + '/order-return-button',
      ORDER_HISTORY: PROXY_BASE_PATH + '/order-history',
      ORDER_DETAILS: PROXY_BASE_PATH + '/order-details',
      DELETE_ACCOUNT: PROXY_BASE_PATH + '/delete-account',
      CREATE_CUSTOMER: PROXY_BASE_PATH + '/customer-create',
      UPDATE_CUSTOMER: PROXY_BASE_PATH + '/customer-update',
      CUSTOMER_SMS_CONSENT: PROXY_BASE_PATH + '/customer-sms-marketing',
      CUSTOMER_WISHLIST: PROXY_BASE_PATH + '/customer-wishlist',
      STOREFRONT: PROXY_BASE_PATH + '/storefront',
      MARKETING_SUBSCRIBE: PROXY_BASE_PATH + '/marketing-subscribe',
      BACK_IN_STOCK_SUBSCRIBE: PROXY_BASE_PATH + '/back-in-stock-subscribe'
    };
    const API_KLAVIYO = {
      HEADERS: {
        'revision': '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      BACK_IN_STOCK_SUB: KLAVIYO_BASE_PATH + `/back-in-stock-subscriptions/?company_id=${KLAVIYO_ID}`,
      SUBSCRIPTION: KLAVIYO_BASE_PATH + `/subscriptions?company_id=${KLAVIYO_ID}`,
      EVENT: KLAVIYO_BASE_PATH + `/profiles?company_id=${KLAVIYO_ID}`
    };
    const FOCUSABLE_SELECTORS = ['button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'].join(', ');

    class ComponentModal extends HTMLElement {
      previousActiveElement = null;
      constructor() {
        super();
        this.elements = {
          closeButton: null,
          focusableElements: null
        };
      }
      connectedCallback() {
        this.render();
        this.initializeElements();
        this.setupEventListeners();
        this.applyAccessibility();
      }
      disconnectedCallback() {
        this.cleanup();
      }
      render() {
        this.style.visibility = 'hidden';
        this.style.opacity = '0';
      }
      initializeElements() {
        this.elements.closeButton = this.querySelector('.component-modal__close');
        this.initFocusableElements();
      }
      setupEventListeners() {
        this.elements.closeButton?.addEventListener('click', this.close.bind(this));
        this.addEventListener('click', (e => {
          if (e.target === this) this.close();
        }).bind(this));
      }
      applyAccessibility() {
        this.addEventListener('keydown', this.handleKeyDown.bind(this));
      }
      handleKeyDown(e) {
        switch (e.key) {
          case 'Escape':
            this.close();
            break;
          case 'Tab':
            this.manageFocus(e);
            break;
        }
      }
      initFocusableElements() {
        this.elements.focusableElements = Array.from(this.querySelectorAll(FOCUSABLE_SELECTORS));
      }
      manageFocus(e) {
        const elements = this.elements.focusableElements;
        if (!elements?.length) return;
        const firstElement = elements[0];
        const lastElement = elements[elements.length - 1];
        const isTabbing = !e.shiftKey;
        const isReverseTabbing = e.shiftKey;
        if (isReverseTabbing && document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        } else if (isTabbing && document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
      open() {
        this.previousActiveElement = document.activeElement ?? null;
        this.ariaHidden = 'false';
        this.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        setTimeout((() => {
          this.style.visibility = 'visible';
          this.style.opacity = '1';
        }).bind(this), 70);
        this.initFocusableElements();
        setTimeout(() => {
          if (this.elements.focusableElements) this.elements.focusableElements[0].focus();
        }, 100);
      }
      close() {
        this.ariaHidden = 'true';
        this.style.visibility = 'hidden';
        this.style.opacity = '0';
        document.body.style.overflow = '';
        setTimeout((() => {
          this.style.display = 'none';
        }).bind(this), 400);
        this.previousActiveElement?.focus();
      }
      cleanup() {
        this.elements.closeButton?.removeEventListener('click', this.close.bind(this));
        this.removeEventListener('keydown', this.handleKeyDown.bind(this));
      }
      static define() {
        if (!customElements.get('component-modal')) {
          customElements.define('component-modal', ComponentModal);
        }
      }
    }
    var componentModal = () => {
      ComponentModal.define();
    };

    var componentModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentModal: ComponentModal,
        default: componentModal
    });

    const {
      getElementByRef: getElementByRef$c
    } = window.PoleneLibs.Refs;
    class ComponentProductCard extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {}
      init() {
        this.handleImgLoad();
      }
      handleImgLoad = () => {
        const {
          productCardImg
        } = getElementByRef$c('product-card-img', this);
        if (!productCardImg) return;
        const {
          imgSrc
        } = productCardImg.dataset;
        const pImg = new Image();
        if (imgSrc) {
          pImg.src = imgSrc;
          pImg.addEventListener('load', () => {
            if (productCardImg?.parentNode instanceof HTMLElement) {
              productCardImg.parentNode.classList.add('is-visible');
            }
          });
        }
      };
      static define() {
        if (!customElements.get('component-product-card')) {
          customElements.define('component-product-card', ComponentProductCard);
        }
      }
    }
    var componentProductCard = () => {
      ComponentProductCard.define();
    };

    var componentProductCard$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductCard
    });

    const {
      wrappedLoader
    } = window.PoleneLibs.ElementTemplates;
    const events$a = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$7,
      parseProductForm
    } = window.PoleneLibs.Utils;
    const {
      getRefs: getRefs$c
    } = window.PoleneLibs.Refs;
    const root = window.Shopify?.routes.root;
    const selectors$a = {
      cartCounter: '.js-cart-counter',
      variantInput: '.js-variant-input'
    };
    const added_to_cart$1 = window.translations?.added_to_cart || 'Added to cart';
    const addToCart = lineItems => {
      const promise = fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(lineItems)
      }).catch(error => {});
      promise.then(response => {
        if (response instanceof Response && response.status >= 200 && response.status < 300) {
          response.json().then(json => dispatchEvent$7(window, events$a.CART_UPDATED, json));
        }
      }).catch(error => {});
      return promise;
    };
    const changeCart = async (id, quantity) => {
      const promise = fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          quantity,
          id,
          sections: 'main-cart'
        })
      }).catch(error => {});
      return promise.then(response => {
        if (response instanceof Response) {
          return response.json();
        }
      }).then(json => {
        if (json && 'sections' in json) {
          updateCartContent(json.sections['main-cart']);
        }
        return json;
      }).catch(error => {
        return {};
      });
    };
    const updateCart = async updates => {
      const promise = fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates,
          sections: 'main-cart,cart-notification-product'
        })
      }).catch(error => {});
      promise.then(response => {
        if (response instanceof Response) {
          return response.json();
        }
      }).then(json => {
        if (json && 'sections' in json) {
          updateCartContent(json.sections['main-cart']);
        }
      });
    };
    const fetchCart = async () => {
      try {
        const response = await fetch(root + 'cart.js', {
          method: 'GET'
        });
        const cart = await response.json();
        fetchHandler(cart);
      } catch (error) {}
    };
    const updateCartContent = section => {
      let parser = new DOMParser();
      let htmlDocument = parser.parseFromString(section, 'text/html');
      const {
        cart
      } = getRefs$c();
      const refs = getRefs$c(cart);
      const listItems = htmlDocument.documentElement.querySelector(`[data-ref="cart-line-items"]`);
      const total = htmlDocument.documentElement.querySelector(`[data-ref="cart-total"]`);
      if (refs && listItems && total) {
        refs.cartLineItems.innerHTML = listItems.innerHTML;
        refs.cartTotal.innerHTML = total.innerHTML;
        dispatchEvent$7(window, events$a.CART_UPDATED);
        dispatchEvent$7(window, events$a.CART_DOM_UPDATED);
      } else {
        cart.innerHTML = section;
        setCartCount(0);
      }
    };
    const fetchHandler = cart => {
      updateCartCount(cart);
    };
    const updateCartCount = cart => {
      setTimeout(() => {
        setCartCount(cart.item_count);
      });
    };
    const setCartCount = amount => {
      const counters = document.querySelectorAll(selectors$a.cartCounter);
      counters.forEach(counter => {
        const currentText = counter.innerHTML;
        const newText = counter.classList.contains('visually-hidden') ? currentText.replace(/\d+/, amount.toString()) : amount.toString();
        counter.innerHTML = newText;
      });
    };
    const handleAddToCart = async productForm => {
      const forms = productForm.getElementsByTagName('form');
      const form = forms[0];
      const formData = new FormData(form);
      const items = parseProductForm(formData);
      const btns = form.getElementsByTagName('button');
      const inputs = form.getElementsByTagName('input');
      const submitBtn = btns[0];
      const defaultsubmitBtnState = submitBtn.dataset.state;
      let preOrderBtn = false;
      let preOrderLabel = '';
      let eContainer;
      const states = {
        success: 'success',
        loading: 'loading',
        default: 'default',
        disabled: 'disabled'
      };
      if (submitBtn.dataset.state == states.disabled) {
        let variantId = null;
        if (!items.length) {
          variantId = form.querySelectorAll(selectors$a.variantInput)[0].value;
        } else {
          variantId = items[0].id;
          const hasOptions = form.getElementsByTagName('option');
          if (hasOptions && items[0].id === '0') {
            variantId = form.getElementsByTagName('option')[1].value;
          }
        }
        dispatchEvent$7(window, events$a.TOGGLE_BIS, {
          variantId
        });
        return;
      }
      if (productForm.nextElementSibling) {
        const {
          errorContainer
        } = getRefs$c(productForm.nextElementSibling);
        eContainer = errorContainer;
      }
      if (!submitBtn.firstElementChild) {
        preOrderBtn = true;
        preOrderLabel = submitBtn.innerHTML;
        submitBtn.innerHTML = wrappedLoader;
      }
      submitBtn.dataset.state = states.loading;
      const add = addToCart({
        items,
        sections: 'main-cart,cart-notification-product'
      });
      add.then(response => {
        if (response instanceof Response) {
          if (response.status >= 200 && response.status < 300) {
            submitBtn.dataset.state = states.success;
            if (eContainer && eContainer.innerHTML) eContainer.innerHTML = '';
            if (preOrderBtn) submitBtn.innerHTML = added_to_cart$1;
            setTimeout(() => {
              submitBtn.dataset.state = defaultsubmitBtnState;
              [...inputs].forEach(input => {
                input.checked = false;
              });
              if (preOrderBtn) {
                submitBtn.innerHTML = preOrderLabel;
              }
            }, 3000);
          } else {
            response.json().then(json => {
              submitBtn.dataset.state = defaultsubmitBtnState;
              if (eContainer) {
                eContainer.innerHTML = json.description;
                setTimeout(() => {
                  eContainer.innerHTML = '';
                }, 5000);
              }
            });
          }
        }
      });
    };

    const {
      getElementByRef: getElementByRef$b
    } = window.PoleneLibs.Refs;
    const events$9 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$6,
      isMobile: isMobile$2
    } = window.PoleneLibs.Utils;
    const VS_TRANSITION_DURATION = 1000;
    const selectors$9 = {
      sizeSelector: '.js-size-selector',
      productForm: '.js-product-form',
      productAnchor: '.js-product-anchor',
      addToCart: '.js-add-to-cart',
      faveBtn: '.js-fave-btn'
    };
    const classes$b = {
      preorderInput: 'preorder-note',
      mobile: 'is-mobile',
      preorderOverlay: 'is-preorder-overlay'
    };
    class ComponentProductForm extends HTMLElement {
      productForm = this.getElementsByTagName('form')[0];
      refs = getElementByRef$b('variant-selector', this);
      isVariantSelectorHovered = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        this.productForm.removeEventListener('input', this.handleFormChange);
        this.removeEventListener('click', this.handleClick);
        if (this.refs.variantSelector) {
          this.refs.variantSelector.removeEventListener('mouseenter', this.handleVSelectorMouseenter);
          this.refs.variantSelector.removeEventListener('mouseleave', this.handleVSelectorMouseleave);
        }
      }
      init() {
        if (this.productForm) {
          this.productForm.addEventListener('input', this.handleFormChange);
        }
        if (!this.classList.contains('is-mini')) {
          this.addEventListener('click', this.handleClick);
        }
        if (this.refs.variantSelector) {
          this.refs.variantSelector.addEventListener('mouseenter', this.handleVSelectorMouseenter);
          this.refs.variantSelector.addEventListener('mouseleave', this.handleVSelectorMouseleave);
        }
      }
      handleVSelectorMouseenter = () => {
        if (isMobile$2()) return;
        if (this.refs.variantSelector && this.isVariantSelectorHovered === false) {
          this.isVariantSelectorHovered = true;
          this.refs.variantSelector.disabled = true;
          this.timeoutId = setTimeout(() => {
            if (this.isVariantSelectorHovered === true) this.refs.variantSelector.disabled = false;
            if (this.timeoutId) {
              clearTimeout(this.timeoutId);
              this.timeoutId = 0;
            }
          }, VS_TRANSITION_DURATION);
        }
      };
      handleVSelectorMouseleave = () => {
        if (isMobile$2()) return;
        if (this.refs.variantSelector && this.isVariantSelectorHovered === true) {
          this.isVariantSelectorHovered = false;
          this.refs.variantSelector.disabled = true;
        }
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
          this.timeoutId = 0;
        }
      };
      handleFormChange = event => {
        event.preventDefault();
        if (!(event.target instanceof HTMLInputElement)) return;
        if (event.target.dataset.availability == 'false') {
          dispatchEvent$6(window, events$9.TOGGLE_BIS, {
            variantId: event.target.value
          });
          return;
        } else {
          const productForm = event.target.closest(selectors$9.productForm);
          if (productForm) {
            handleAddToCart(productForm);
          }
        }
      };
      handleClick = event => {
        if (!event.target || !(event.target instanceof Element) || !(event.currentTarget instanceof Element)) {
          return;
        }
        const productForm = event.target.closest(selectors$9.productForm);
        const sizeSelector = event.target.closest(selectors$9.sizeSelector);
        const faveBtn = event.target.closest(selectors$9.faveBtn);
        const productAnchor = event.currentTarget.querySelector(selectors$9.productAnchor);
        if (faveBtn || sizeSelector) return;
        if (productForm) {
          event.preventDefault();
          const btns = productForm.getElementsByTagName('button');
          const submitBtn = btns[0];
          const preOrderInput = productForm.getElementsByClassName(classes$b.preorderInput);
          if (this.classList.contains('quick-buy-form') && productForm.querySelector(selectors$9.sizeSelector) && isMobile$2()) {
            this.updateCartNotification(productForm, classes$b.mobile, 'variantSelector');
            return;
          }
          if (preOrderInput.length && isMobile$2()) {
            this.updateCartNotification(productForm, classes$b.preorderOverlay, 'preorder');
            return;
          }
          if (submitBtn.dataset.state === 'inactive') {
            return;
          }
          handleAddToCart(productForm);
          return;
        }
        if (productAnchor) {
          const url = productAnchor.getAttribute('href');
          if (url) {
            window.location.href = url;
          }
        }
      };
      updateCartNotification = (form, className, state) => {
        const clone = form.cloneNode(true);
        const obj = {
          element: clone,
          className,
          state,
          handle: form.dataset.handle
        };
        dispatchEvent$6(window, events$9.TRIGGER_NOTIFICATION_LAYOUT, obj);
      };
      static define() {
        if (!customElements.get('component-product-form')) {
          customElements.define('component-product-form', ComponentProductForm);
        }
      }
    }
    var componentProductForm = () => {
      ComponentProductForm.define();
    };

    var componentProductForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductForm
    });

    const SEARCH_PARAM = 'openCountrySelector';
    const CLOSE_BUTTON_SELECTOR = '.country-selector__popup__header__close';
    const focusLock = window.PoleneVendors.focusLock;
    class CountrySelectorModal {
      constructor() {
        this.selectorModals = document.querySelectorAll('.selector_popup');
        this.selectorButtons = document.querySelectorAll('.selector-button');
        this.boundHandleEscapeKeydown = this.handleEscapeKeydown.bind(this);
        this.boundHandleButtonClick = this.handleButtonClick.bind(this);
        this.boundCloseModal = this.closeModal.bind(this);
      }
      handleButtonClick(event) {
        const button = event.currentTarget;
        const countrySelectorModal = document.querySelector(`#${button.dataset.puid}`);
        if (countrySelectorModal) {
          this.showModal(countrySelectorModal);
        }
      }
      showModal(countrySelectorModal) {
        if (!countrySelectorModal) return;
        const closeModalButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
        if (closeModalButton) {
          closeModalButton.addEventListener('click', this.boundCloseModal);
        }
        document.addEventListener('keydown', this.boundHandleEscapeKeydown);
        countrySelectorModal.classList.add('is-open');
        document.querySelector('body')?.classList.add('country-selector-modal-is-open');
        countrySelectorModal.setAttribute('tabindex', '0');
        focusLock.on(countrySelectorModal);
      }
      closeModal() {
        const countrySelectorModal = document.querySelector('.selector_popup.is-open');
        if (countrySelectorModal) {
          countrySelectorModal.classList.remove('is-open');
          document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
          focusLock.off(countrySelectorModal);
          this.clearEvents(countrySelectorModal);
          const url = new URL(window.location.href);
          const urlParams = new URLSearchParams(url.search);
          urlParams.delete(SEARCH_PARAM);
          url.search = urlParams.toString();
          window.history.replaceState({}, document.title, url.toString());
        }
      }
      clearEvents(countrySelectorModal) {
        const modalCloseButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
        document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
        if (modalCloseButton) {
          modalCloseButton.removeEventListener('click', this.boundCloseModal);
        }
      }
      handleEscapeKeydown(event) {
        if (event.key === 'Escape') {
          this.closeModal();
        }
      }
      getSearchParam() {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        urlParams.delete('country');
        url.search = urlParams.toString();
        window.history.replaceState({}, document.title, url.toString());
        return urlParams.has(SEARCH_PARAM);
      }
      setupEventListeners() {
        if (!this.selectorModals || this.selectorButtons.length === 0) return;
        this.selectorButtons.forEach(button => {
          button.addEventListener('click', this.boundHandleButtonClick);
        });
      }
      cleanup() {
        if (this.selectorButtons) {
          this.selectorButtons.forEach(button => {
            button.removeEventListener('click', this.boundHandleButtonClick);
          });
        }
        document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
        if (this.selectorModals) {
          this.selectorModals.forEach(modal => {
            if (modal.classList.contains('is-open')) {
              this.clearEvents(modal);
              focusLock.off(modal);
              modal.classList.remove('is-open');
            }
          });
        }
        document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
      }
      init() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.setupEventListeners();
          });
        } else {
          this.setupEventListeners();
        }
        if (this.getSearchParam()) {
          const defaultModal = this.selectorModals[0];
          if (defaultModal) {
            this.showModal(defaultModal);
          }
        }
        return this.cleanup.bind(this);
      }
    }
    var countrySelectorModal = () => {
      const modal = new CountrySelectorModal();
      return modal.init();
    };

    var countrySelectorModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CountrySelectorModal: CountrySelectorModal,
        default: countrySelectorModal
    });

    const {
      getElementsByRef: getElementsByRef$8
    } = window.PoleneLibs.Refs;
    const events$8 = window.PoleneLibs.Events.default;
    class CustomerWishlist {
      constructor() {
        const {
          collectionSection
        } = getElementsByRef$8('collection-section');
        this.wishlistContainer = collectionSection ? Array.isArray(collectionSection) ? collectionSection : [collectionSection] : undefined;
        const {
          wishlistGrid
        } = getElementsByRef$8('wishlist-grid');
        this.wishlistGridContainer = wishlistGrid ? Array.isArray(wishlistGrid) ? wishlistGrid : [wishlistGrid] : undefined;
        this.init();
      }
      async fetchWishlist(handles) {
        const response = await fetch(`${API_PROXY.CUSTOMER_WISHLIST}`, {
          method: 'POST',
          body: JSON.stringify({
            handles: handles
          })
        });
        if (!response.ok) {
          throw new Error('Failed to fetch customer wishlist');
        }
        return response.text();
      }
      async init() {
        let wishlistKing;
        if (!this.wishlistGridContainer || !this.wishlistContainer) {
          return;
        }
        wishlistKing = window.WishlistKing;
        const collection = await wishlistKing.toolkit.collection.get();
        if (collection.products.length) {
          this.wishlistContainer.forEach(container => {
            container.dataset.state = 'filled';
          });
          const handles = collection.products.map(product => product.handle);
          const fetchedWishlist = await this.fetchWishlist(handles);
          this.wishlistGridContainer.forEach(container => {
            container.innerHTML = fetchedWishlist;
            const event = new CustomEvent('PRODUCT_CARD_RENDERED');
            window.dispatchEvent(event);
            container?.classList.add('is-revealed');
          });
        } else {
          this.wishlistContainer.forEach(container => {
            container.dataset.state = 'empty';
          });
        }
        if (!this.wishlistGridContainer) {
          return;
        }
      }
      destroy() {}
    }
    var customerWishlist = async () => {
      const {
        wishlistGrid
      } = getElementsByRef$8('wishlist-grid');
      if (window.WishlistKing && wishlistGrid) {
        try {
          const wishlist = new CustomerWishlist();
          return () => {
            wishlist.destroy();
          };
        } catch (error) {}
      } else {
        window.addEventListener(events$8.WISHLIST_READY, () => {
          try {
            const wishlist = new CustomerWishlist();
            return () => {
              wishlist.destroy();
            };
          } catch (error) {}
        });
      }
      return () => {
        window.removeEventListener(events$8.WISHLIST_READY, () => {
          try {
            const wishlist = new CustomerWishlist();
            return () => {
              wishlist.destroy();
            };
          } catch (error) {}
        });
      };
    };

    var customerWishlist$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerWishlist
    });

    const validateEmail = email => {
      if (/^[\w+.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        return true;
      }
      return false;
    };

    const events$7 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$5
    } = window.PoleneLibs.Utils;
    const {
      getElementsByRef: getElementsByRef$7,
      getRefs: getRefs$b
    } = window.PoleneLibs.Refs;
    const {
      storeLanguage: storeLanguage$1
    } = window.PoleneLibs.ConstantsDate;
    const states$1 = {
      submitted: 'submitted',
      error: 'error',
      noEmail: 'no-email'
    };
    const selectors$8 = {
      bisForm: '.js-bis-form',
      bisContainer: '.js-bis-container'
    };
    var bisForm = () => {
      const {
        bis
      } = getElementsByRef$7('bis');
      if (!bis || Array.isArray(bis)) return;
      const bisContainers = bis ? Array.isArray(bis) ? bis : [bis] : [];
      let newsletterConsent;
      const init = () => {
        newsletterConsent = bis.querySelector('input[id="newsletter-checkbox"]');
        setEventListeners();
      };
      const setEventListeners = () => {
        window.addEventListener(events$7.TOGGLE_BIS, handleBisData);
        bisContainers.forEach(bis => {
          const {
            bisForm
          } = getRefs$b(bis);
          if (bisForm) {
            bisForm.addEventListener('submit', handleSubmit);
          }
        });
      };
      const handleBisData = e => {
        const {
          variantId
        } = e.detail;
        bisContainers.forEach(bis => {
          const {
            bisForm
          } = getRefs$b(bis);
          if (bisForm) {
            bisForm.dataset.variantId = variantId || '';
          }
        });
      };
      const requestBackInStockSubscription = async (email, variantId, emailMarketingConsent) => {
        const formData = new FormData();
        formData.set('email', email);
        formData.set('locale', storeLanguage$1);
        formData.set('email_marketing_consent', JSON.stringify(emailMarketingConsent));
        formData.set('variant_id', variantId);
        return fetch(`${API_PROXY.BACK_IN_STOCK_SUBSCRIBE}`, {
          method: 'POST',
          body: formData
        });
      };
      const handleSubmit = async e => {
        e.preventDefault();
        const bisForm = e.target.closest(selectors$8.bisForm);
        const bisContainer = e.target.closest(selectors$8.bisContainer);
        const {
          variantId
        } = e.target.dataset;
        const {
          bisEmail
        } = getRefs$b(bisForm);
        if (!bisEmail.value || !validateEmail(bisEmail.value)) {
          bis.dataset.state = states$1.noEmail;
          return;
        }
        try {
          const response = await requestBackInStockSubscription(bisEmail.value, variantId, newsletterConsent?.checked ?? false);
          if (response.status === 202) {
            bisContainer.dataset.state = states$1.submitted;
            updateBackInStockSubscriptions(variantId);
          } else {
            bisContainer.dataset.state = states$1.error;
          }
        } catch (error) {
          bisContainer.dataset.state = states$1.error;
        }
      };
      const updateBackInStockSubscriptions = variantId => {
        const storageKey = 'back-in-stock-subscriptions';
        let backInStockSubscriptions = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!backInStockSubscriptions.includes(variantId)) {
          backInStockSubscriptions.push(variantId);
          localStorage.setItem(storageKey, JSON.stringify(backInStockSubscriptions));
        }
        dispatchEvent$5(window, events$7.UPDATE_BIS, {
          variantId
        });
      };
      init();
      return () => {
        window.removeEventListener(events$7.TOGGLE_BIS, handleBisData);
        bisContainers.forEach(bis => {
          const {
            bisForm
          } = getRefs$b(bis);
          if (bisForm) {
            bisForm.removeEventListener('submit', handleSubmit);
          }
        });
      };
    };

    var bisForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: bisForm
    });

    const events$6 = window.PoleneLibs.Events.default;
    const scrollLock$4 = window.PoleneLibs.ScrollLock.default;
    const {
      dispatchEvent: dispatchEvent$4
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$a,
      getElementsByRef: getElementsByRef$6,
      getRefs: getRefs$a
    } = window.PoleneLibs.Refs;
    const selectors$7 = {
      image: '.js-zoom-image',
      bg: '.js-bg',
      close: '.js-close',
      submitBtn: '.js-submit-btn',
      zoomedImg: '.js-zoomed-img'
    };
    const classes$a = {
      modalOpen: 'modal-open',
      visible: 'is-visible'
    };
    const types = {
      zoom: {
        name: 'image-zoom',
        config: {
          modalClose: true
        }
      },
      bis: {
        name: 'bis',
        config: {
          modalClose: true
        }
      }
    };
    var bisModal = () => {
      const {
        modal,
        bis
      } = getElementByRef$a(['modal', 'bis']);
      const {
        modalTrigger
      } = getElementsByRef$6(['modal-trigger']);
      if (!modal) return;
      let zoomImage;
      let modalOpen = false;
      let type;
      let previousActiveElement = null;
      let focusableElements = null;
      const {
        imageContainer
      } = getRefs$a(modal);
      const triggers = modalTrigger ? Array.isArray(modalTrigger) ? [...modalTrigger] : [modalTrigger] : [];
      let variantId = undefined;
      const init = () => {
        setEventlisteners();
      };
      const initFocusableElements = () => {
        if (!bis) return;
        focusableElements = Array.from(bis.querySelectorAll(FOCUSABLE_SELECTORS));
      };
      const setEventlisteners = () => {
        modal.addEventListener('click', handleClick);
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener(events$6.TOGGLE_BIS, handleToggleBis);
        window.addEventListener(events$6.UPDATE_BIS, () => {
          updateModalContent(true);
        });
        if (triggers.length) {
          triggers.forEach(trigger => {
            trigger.addEventListener('click', handleClick);
            if (trigger.dataset.imagesrc) {
              trigger.addEventListener('mouseenter', handleMouseOver);
              trigger.addEventListener('mouseleave', handleMouseLeave);
            }
          });
        }
      };
      const handleToggleBis = event => {
        if (event.detail.variantId) variantId = event.detail.variantId;
        type = types.bis;
        toggleModal(true, type);
      };
      const handleClick = e => {
        e.stopPropagation();
        const image = e.target.closest(selectors$7.image);
        const bg = e.target.closest(selectors$7.bg);
        const close = e.target.closest(selectors$7.close);
        const zoomed = e.target.closest(selectors$7.zoomedImg);
        if (image) {
          type = types.zoom;
          toggleModal(true, type);
          handleImageZoom(image.dataset.imagesrc);
        }
        if (bg) {
          if (type && type.config.modalClose) {
            toggleModal(false);
          }
        }
        if (close || zoomed) {
          toggleModal(false);
        }
      };
      const handleKeyDown = e => {
        if (e.key === 'Escape' && modalOpen) {
          toggleModal(false);
        } else if (e.key === 'Tab' && modalOpen) {
          manageFocus(e);
        }
      };
      const manageFocus = e => {
        if (!focusableElements?.length) return;
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const isTabbing = !e.shiftKey;
        const isReverseTabbing = e.shiftKey;
        if (isReverseTabbing && document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        } else if (isTabbing && document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      };
      const toggleModal = (state, type) => {
        modalOpen = state;
        scrollLock$4(modalOpen);
        let hideForm = variantIsSubscribed(variantId) ? true : false;
        updateModalContent(hideForm);
        if (modalOpen) {
          previousActiveElement = document.activeElement;
          document.body.classList.add(classes$a.modalOpen);
          document.body.dataset.modal = type.name;
          requestAnimationFrame(() => {
            if (bis) {
              bis.setAttribute('aria-hidden', 'false');
              initFocusableElements();
              const closeButton = bis.querySelector('.js-close');
              setTimeout(() => {
                closeButton?.focus();
              }, 1000);
            }
          });
        } else {
          if (imageContainer) {
            zoomImage = null;
            imageContainer.innerHTML = '';
            dispatchEvent$4(window, events$6.CHANGE_CURSOR, {
              type: 'default',
              contrast: false
            });
          }
          document.body.classList.remove(classes$a.modalOpen);
          if (bis) {
            bis.setAttribute('aria-hidden', 'true');
          }
          previousActiveElement?.focus();
          focusableElements = null;
        }
      };
      const handleMouseOver = () => {
        dispatchEvent$4(window, events$6.CHANGE_CURSOR, {
          type: 'zoom',
          contrast: true
        });
      };
      const handleMouseLeave = () => {
        if (!modalOpen) {
          dispatchEvent$4(window, events$6.CHANGE_CURSOR, {
            type: 'default',
            contrast: false
          });
        }
      };
      const handleImageZoom = image => {
        imageContainer.getBoundingClientRect();
        dispatchEvent$4(window, events$6.CHANGE_CURSOR, {
          type: 'close',
          contrast: true
        });
        zoomImage = document.createElement('img');
        zoomImage.setAttribute('class', 'modal__zoom-img js-zoomed-img');
        zoomImage.setAttribute('src', image);
        imageContainer.appendChild(zoomImage);
      };
      const updateModalContent = hide => {
        const form = modal.querySelector('form.js-bis-form');
        const formInput = modal.querySelector('div.form-input');
        const formButton = modal.querySelector(selectors$7.submitBtn);
        const formContainer = modal.querySelector('.js-bis-container');
        const formNewsletter = modal.querySelector('.bis-form__newsletter');
        if (formInput && formButton && formContainer && form && formNewsletter) {
          formInput.classList.toggle('is-hidden', hide);
          formButton.classList.toggle('is-hidden', hide);
          form.classList.toggle('is-hidden', hide);
          formNewsletter.classList.toggle('is-hidden', hide);
          if (hide === true) {
            formContainer.dataset.state = 'submitted';
          } else {
            formContainer.dataset.state = '';
          }
        }
      };
      const variantIsSubscribed = productId => {
        return getBackInStockSubscriptions().includes(productId);
      };
      const getBackInStockSubscriptions = () => {
        const storageKey = 'back-in-stock-subscriptions';
        let backInStockSubscriptions = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return backInStockSubscriptions;
      };
      init();
      return () => {
        modal.removeEventListener('click', handleClick);
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener(events$6.TOGGLE_BIS, handleToggleBis);
        window.removeEventListener(events$6.UPDATE_BIS, () => {
          updateModalContent(true);
        });
        if (triggers.length) {
          triggers.forEach(trigger => {
            trigger.removeEventListener('click', handleClick);
            if (trigger.dataset.imagesrc) {
              trigger.removeEventListener('mouseenter', handleMouseOver);
              trigger.removeEventListener('mouseleave', handleMouseLeave);
            }
          });
        }
      };
    };

    var bisModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: bisModal
    });

    var InputFields;
    (function (InputFields) {
      InputFields["FirstName"] = "firstName";
      InputFields["LastName"] = "lastName";
      InputFields["Address1"] = "address1";
      InputFields["Address2"] = "address2";
      InputFields["Zip"] = "zip";
      InputFields["City"] = "city";
      InputFields["Phone"] = "phone";
      InputFields["Birthdate"] = "birthdate";
      InputFields["email"] = "email";
      InputFields["password"] = "password";
      InputFields["confirmPassword"] = "confirmPassword";
      InputFields["civility"] = "civility";
    })(InputFields || (InputFields = {}));
    const FormSelectors = {
      Customer: {
        BIRTHDATE: 'input[name=birthdate]',
        PHONE: 'input[name="phone"]',
        PHONE_COUNTRY_SELECT: 'select[name="phone_country_select"]',
        SUBMIT_BUTTON: 'button[type="submit"]',
        FIRST_NAME: 'input[name="firstName"]',
        LAST_NAME: 'input[name="lastName"]',
        EMAIL: 'input[name="email"]',
        PASSWORD: 'input[name="password"]',
        CIVILITY: 'select[name="civility"]',
        Shopify: {
          Selectors: {
            EMAIL: 'input[name="customer[email]"]',
            PASSWORD: 'input[name="customer[password]"]',
            CONFIRM_PASSWORD: 'input[name="customer[password_confirmation]"]'
          }
        },
        RecoverPassword: {
          EMAIL: 'input[name="email"]'
        },
        Update: {
          ID: '#profile_form',
          FORM: '#update_customer_form',
          Selectors: {
            FIRST_NAME: 'input[name="firstName"]',
            LAST_NAME: 'input[name="lastName"]',
            PHONE: 'input[name="phone"]'
          },
          Fields: {
            FirstName: 'firstName',
            LastName: 'lastName',
            Phone: 'phone'
          }
        },
        Address: {
          COUNTRY_SELECT: 'select[name="address[country]"]',
          PHONE: 'input[name="address[phone]"]',
          FIRST_NAME: 'input[name="address[first_name]"]',
          LAST_NAME: 'input[name="address[last_name]"]',
          ADDRESS_1: 'input[name="address[address1]"]',
          ADDRESS_2: 'input[name="address[address2]"]',
          ZIP: 'input[name="address[zip]"]',
          CITY: 'input[name="address[city]"]'
        }
      }
    };
    const defaultNoValidationConf = {
      noSpecialChar: undefined,
      nonLatinCharacters: undefined,
      noNumber: undefined,
      maxLength: undefined,
      minLength: 0,
      required: false
    };
    const inputTextDefaultValidationConf = {
      nonLatinCharacters: true,
      noSpecialChar: true,
      noNumber: true,
      maxLength: 35,
      minLength: 0,
      required: true
    };
    const FormValidations = {
      [InputFields.FirstName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.LastName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.Address1]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: true
      },
      [InputFields.Address2]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: false
      },
      [InputFields.City]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: undefined,
        required: true
      },
      [InputFields.Zip]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: 10,
        required: true
      },
      [InputFields.Phone]: {
        ...defaultNoValidationConf
      },
      [InputFields.email]: {
        ...defaultNoValidationConf,
        required: true
      },
      [InputFields.password]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.confirmPassword]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.civility]: {
        ...defaultNoValidationConf,
        required: true
      },
      [InputFields.Birthdate]: {
        ...inputTextDefaultValidationConf,
        nonLatinCharacters: false,
        noSpecialChar: false,
        maxDate: Date.now(),
        required: false,
        noNumber: false
      }
    };

    var ErrorTypes;
    (function (ErrorTypes) {
      ErrorTypes["invalidTitle"] = "invalid_title";
      ErrorTypes["invalidName"] = "invalid_name";
      ErrorTypes["invalidCivility"] = "invalid_civility";
      ErrorTypes["nonLatinCharacters"] = "contains_non_latin_characters";
      ErrorTypes["maxLengthExceeded"] = "max_length_exceeded";
      ErrorTypes["minLength"] = "min_length";
      ErrorTypes["containsNumbers"] = "contains_numbers";
      ErrorTypes["containsSpecialChars"] = "contains_special_chars";
      ErrorTypes["empty"] = "empty";
      ErrorTypes["phoneNumberInvalid"] = "phone_number_invalid";
      ErrorTypes["formSubmitError"] = "form_error";
      ErrorTypes["TAKEN"] = "email_taken";
      ErrorTypes["maxDate"] = "max_date";
      ErrorTypes["invalidDate"] = "invalid_date";
    })(ErrorTypes || (ErrorTypes = {}));

    const containsNonLatinCharactersFieldError = str => {
      const nonLatinRegex = /[^\u0000-\u017F]+/;
      return nonLatinRegex.test(str || '');
    };
    const validateNotContainsNonLatinCharacters = str => {
      if (containsNonLatinCharactersFieldError(str)) {
        return {
          isValid: false,
          error: ErrorTypes.nonLatinCharacters
        };
      }
      return {
        isValid: true
      };
    };
    function validateMaxLength(str, maxLength) {
      if (str.length > maxLength) {
        return {
          isValid: false,
          error: ErrorTypes.maxLengthExceeded
        };
      }
      return {
        isValid: true
      };
    }
    function validateMinLength(str, minLength) {
      if (str.length < minLength) {
        return {
          isValid: false,
          error: ErrorTypes.minLength
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoNumbers(str) {
      const numberRegex = /\d/;
      if (numberRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsNumbers
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoSpecialChars(str) {
      const specialCharsRegex = /[%_;|]/;
      if (specialCharsRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsSpecialChars
        };
      }
      return {
        isValid: true
      };
    }
    function validateNotEmpty(str) {
      const withoutWhiteSpace = str.replace(/\s/g, '');
      if (withoutWhiteSpace.length <= 0) return {
        isValid: false,
        error: ErrorTypes.empty
      };
      return {
        isValid: true
      };
    }
    function validateMaxDate(inputTimestamp, limitTimestamp) {
      if (inputTimestamp > limitTimestamp) {
        return {
          isValid: false,
          error: ErrorTypes.maxDate
        };
      }
      return {
        isValid: true
      };
    }
    function validateDate(ts) {
      return !ts ? {
        isValid: false,
        error: ErrorTypes.invalidDate
      } : {
        isValid: true
      };
    }

    const DateFormat = window.PoleneLibs.DateFormat;
    class InputValidation {
      inputs = {};
      dateFormat = new DateFormat();
      hasSubmitOnce = false;
      constructor({
        formContainer,
        inputs
      }) {
        this.formContainer = formContainer;
        this.inputs = inputs;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw new Error('Form not found');
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Submit Button not found');
      }
      triggerValidationEffect(input, validation) {
        if (!validation.isValid && validation.error) {
          this.displayErrorSpan(input, validation.error, validation.message);
          if (this.submitButton) this.submitButton.disabled = true;
          return false;
        }
        this.removeErrorSpan(input);
        if (this.submitButton) this.submitButton.disabled = false;
        return true;
      }
      displayErrorSpan(input, error, message) {
        this.removeErrorSpan(input);
        const errorSpan = this.form?.querySelector(`span[data-ref=${input.id}-${error}]`);
        if (!errorSpan) return;
        if (message) errorSpan.textContent = message;
        input.ariaInvalid = 'true';
        input.setAttribute('aria-describedby', `${input.id}-${error}`);
        errorSpan.hidden = false;
        errorSpan.style.display = 'block';
      }
      removeErrorSpan(input) {
        const errorSpans = this.form?.querySelectorAll(`span[data-ref^=${input.id}]`);
        if (!errorSpans) return;
        input.ariaInvalid = 'false';
        input.removeAttribute('aria-describedby');
        errorSpans.forEach(span => {
          span.hidden = true;
          span.style.display = 'none';
        });
      }
      checkRequiredInput({
        input
      }) {
        if (!input) return true;
        let inputIsEmpty = false;
        if (!input.validationConfig.required) return;
        const emptyCheck = validateNotEmpty(input.selector.value);
        if (!this.triggerValidationEffect(input.selector, emptyCheck)) return false;
        inputIsEmpty = true;
        return inputIsEmpty;
      }
      checkRequiredInputs({
        inputs
      }) {
        if (!inputs) return true;
        let formHasEmptyRequiredField = false;
        Object.values(this.inputs).forEach(input => {
          if (!input.validationConfig.required) return;
          const emptyCheck = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, emptyCheck)) return false;
          formHasEmptyRequiredField = true;
        });
        return formHasEmptyRequiredField;
      }
      validateInput(input) {
        if (this.hasSubmitOnce) {
          const empty = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, empty)) {
            return false;
          }
        }
        if (input.selector.dataset.ref == 'input-date' && input.selector.value != `${this.dateFormat.placeholder}  (${input.selector.dataset.tOptional})`) {
          const date = this.dateFormat.parse(input.selector.value);
          const invalidDateCheck = validateDate(date);
          if (!this.triggerValidationEffect(input.selector, invalidDateCheck)) return false;
          if (input.validationConfig.maxDate) {
            const maxDateCheck = validateMaxDate(date ?? NaN, input.validationConfig.maxDate);
            if (!this.triggerValidationEffect(input.selector, maxDateCheck)) return false;
          }
        }
        if (input.validationConfig.noSpecialChar) {
          const speCharCheck = validateNoSpecialChars(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, speCharCheck)) {
            return false;
          }
        }
        if (input.validationConfig.noNumber) {
          const noNumb = validateNoNumbers(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, noNumb)) {
            return false;
          }
        }
        if (input.validationConfig.maxLength) {
          const lengthCheck = validateMaxLength(input.selector.value, input.validationConfig.maxLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.minLength) {
          const lengthCheck = validateMinLength(input.selector.value, input.validationConfig.minLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.nonLatinCharacters) {
          const latinCharactersCheck = validateNotContainsNonLatinCharacters(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, latinCharactersCheck)) {
            return false;
          }
        }
        return true;
      }
      validateForm({
        inputs
      }) {
        let isValid = true;
        Object.values(inputs).forEach(input => {
          if (input.selector.value.trim() !== '') {
            if (!this.validateInput(input)) {
              isValid = false;
            }
          }
        });
        return isValid;
      }
    }

    const {
      getElementByRef: getElementByRef$9
    } = window.PoleneLibs.Refs;
    const handleNewsletterEventSubscription = async formData => {
      let customerIsSubscribedToEvent = true;
      const errorType = ErrorTypes.formSubmitError;
      let errorMessage;
      const {
        newsletterEventForm,
        messageContainerSuccess,
        messageContainerError,
        messageContainerAlreadySignedUp
      } = getElementByRef$9(['newsletter-event-form', 'message-container-success', 'message-container-error', 'message-container-already-signed-up']);
      if (!newsletterEventForm || !messageContainerSuccess || !messageContainerError || !messageContainerAlreadySignedUp) {
        customerIsSubscribedToEvent = false;
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      }
      const {
        eventKey
      } = newsletterEventForm.dataset;
      const customerEmail = formData.get('email');
      if (typeof customerEmail != 'string') {
        messageContainerError.style.display = 'block';
        customerIsSubscribedToEvent = false;
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      } else {
        try {
          const response = await fetch(API_KLAVIYO.EVENT, {
            method: 'POST',
            headers: API_KLAVIYO.HEADERS,
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email: customerEmail,
                  meta: {
                    patch_properties: {
                      append: {
                        event: eventKey
                      }
                    }
                  }
                }
              }
            })
          });
          if (response.status === 202) {
            messageContainerSuccess.style.display = 'block';
            newsletterEventForm.querySelector('input[data-ref="event-form-email"]').value = '';
          } else {
            messageContainerError.style.display = 'block';
          }
        } catch (error) {
          customerIsSubscribedToEvent = false;
        }
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      }
    };

    var handleNewsletterEvent = /*#__PURE__*/Object.freeze({
        __proto__: null,
        handleNewsletterEventSubscription: handleNewsletterEventSubscription
    });

    const {
      getElementsByRef: getElementsByRef$5
    } = window.PoleneLibs.Refs;
    class NewsletterEventForm {
      inputs = {};
      constructor({
        formContainerId
      }) {
        this.formContainer = document.getElementById(formContainerId);
        if (!this.formContainer) throw `Unable to find form container with id: ${formContainerId}`;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw `Unable to find form in the given container: ${formContainerId}`;
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Required elements not found');
        this.inputs = {
          email: {
            selector: this.form.querySelector(FormSelectors.Customer.EMAIL),
            validationConfig: FormValidations.email
          }
        };
        this.init();
      }
      initInputValidation({
        inputs
      }) {
        this.inputValidation = new InputValidation({
          formContainer: this.formContainer,
          inputs: inputs
        });
      }
      handleFormValidation = () => {
        if (!this.inputs.email?.selector) return false;
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleInputValidation = input => {
        if (!input.selector || !input.validationConfig) return false;
        const isValid = this.inputValidation?.validateInput(input);
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      async handleFormSubmit(event) {
        event.preventDefault();
        if (!this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        }) || !this.handleFormValidation) return false;
        const form = event.currentTarget;
        const formData = new FormData(form);
        if (this.submitButton) this.submitButton.disabled = true;
        const newsletterEventSubscriptionHandler = await handleNewsletterEventSubscription(formData);
        if (this.submitButton) {
          if (!newsletterEventSubscriptionHandler.customerIsSubscribedToEvent) {
            this.inputValidation?.triggerValidationEffect(this.submitButton, {
              isValid: newsletterEventSubscriptionHandler.customerIsSubscribedToEvent,
              error: newsletterEventSubscriptionHandler.errorType,
              message: newsletterEventSubscriptionHandler.errorMessage
            });
          }
          this.submitButton.disabled = !newsletterEventSubscriptionHandler.customerIsSubscribedToEvent;
        }
      }
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => {
          return input.selector.addEventListener('blur', () => this.handleInputValidation(input));
        });
      }
      destroy() {
        this.form.removeEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', () => this.handleInputValidation(input)));
      }
    }
    var eventForm = async () => {
      const newsletterEventForm = getElementsByRef$5('newsletter-event-form');
      if (newsletterEventForm) {
        try {
          const form = new NewsletterEventForm({
            formContainerId: 'newsletter-event-form-container'
          });
          return () => {
            form.destroy();
          };
        } catch (error) {}
      }
    };

    var eventForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: eventForm
    });

    const {
      breakpoints: breakpoints$4
    } = window.PoleneLibs.Breakpoints;
    const events$5 = window.PoleneLibs.Events.default;
    const scrollLock$3 = window.PoleneLibs.ScrollLock.default;
    const {
      dispatchEvent: dispatchEvent$3
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$8,
      getRefs: getRefs$9
    } = window.PoleneLibs.Refs;
    const selectors$6 = {
      closeBtn: '.js-close',
      productForm: '.js-product-form',
      sizeSelector: '.js-size-selector',
      bg: '.js-notification-bg'
    };
    const classes$9 = {
      active: 'is-active',
      visible: 'is-visible',
      hidden: 'is-hidden',
      preorderInput: 'preorder-note'
    };
    const states = {
      variantSelector: 'variant-selector',
      productAdded: 'product-added',
      preorder: 'preorder'
    };
    const {
      select_size,
      add_to_cart,
      added_to_cart,
      preorder_subtitle
    } = window.translations;
    let xDown = null;
    let yDown = null;
    let isOpen$1 = false;
    const isMobile$1 = () => window.innerWidth < breakpoints$4.md;
    var fragmentCartNotification = () => {
      const {
        cartNotification
      } = getElementByRef$8('cart-notification');
      if (!cartNotification) return;
      const {
        notificationTitle,
        notificationSubtitle,
        notificationFormtitle,
        notificationProduct,
        notificationProductForm
      } = getRefs$9(cartNotification);
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        window.addEventListener(events$5.CART_UPDATED, handleCartUpdated);
        window.addEventListener(events$5.TRIGGER_NOTIFICATION_LAYOUT, toggleLayout);
        document.addEventListener('touchstart', handleTouchStart, false);
        document.addEventListener('touchmove', handleTouchMove, false);
        cartNotification.addEventListener('click', handleClick);
      };
      const handleCartUpdated = e => {
        if (!e.detail?.sections['cart-notification-product']) return;
        let parser = new DOMParser();
        let markup = parser.parseFromString(e.detail.sections['cart-notification-product'], 'text/html');
        const productCard = markup.documentElement.querySelector(`[id="cart-notification-product-${e.detail.items[0].key}"]`);
        if (!productCard) return;
        notificationProduct.innerHTML = productCard.innerHTML;
        openPopUp(states.productAdded);
        setTimeout(() => {
          closePopUp();
        }, 4000);
      };
      const toggleLayout = async e => {
        let {
          element,
          handle,
          className,
          state
        } = e.detail;
        if (className) element.classList.add(className);
        if (handle) {
          const element = await createProductPreview(handle);
          if (element) notificationProduct.innerHTML = element.innerHTML;
        }
        if (element) notificationProductForm.appendChild(element);
        if (state === states.preorder) {
          const preOrderInput = element.getElementsByClassName(classes$9.preorderInput);
          const shippingInfo = preOrderInput[0].value;
          const preorderSubtitle = preorder_subtitle.replace('{{ shippingInfo }}', shippingInfo);
          notificationSubtitle.innerHTML = preorderSubtitle;
        }
        if (cartNotification.querySelector(selectors$6.productForm)) cartNotification.querySelector(selectors$6.productForm)?.addEventListener('input', handleFormChange);
        openPopUp(states[state]);
      };
      const closePopUp = () => {
        updateState(false);
        const delay = isMobile$1() ? 150 : 600;
        cartNotification.classList.add(classes$9.hidden);
        notificationProduct.classList.remove(classes$9.visible);
        setTimeout(() => {
          notificationProduct.innerHTML = '';
          notificationTitle.innerHTML = '';
          notificationSubtitle.innerHTML = '';
          notificationFormtitle.innerHTML = '';
          notificationProductForm.innerHTML = '';
        }, delay);
      };
      const openPopUp = state => {
        updateState(true);
        cartNotification.dataset.state = state;
        cartNotification.classList.remove(classes$9.hidden);
        cartNotification.classList.add(classes$9.active);
        const content = {
          [states.variantSelector]: {
            title: add_to_cart,
            formtitle: select_size
          },
          [states.preorder]: {
            title: add_to_cart
          },
          [states.productAdded]: {
            title: added_to_cart
          }
        };
        notificationTitle.innerHTML = content[state].title;
        if (content[state].formtitle) {
          notificationFormtitle.innerHTML = content[state].formtitle;
        }
        if (state == states.productAdded || state == states.preorder || state == states.variantSelector) {
          setTimeout(() => {
            notificationProduct.classList.add(classes$9.visible);
          }, 500);
        }
      };
      const updateState = state => {
        isOpen$1 = state;
        if (isMobile$1()) {
          scrollLock$3(state);
        }
      };
      const createProductPreview = async productHandle => {
        try {
          const fetchUrl = `/products/${productHandle}?section_id=cart-notification-preview&product=${productHandle}`;
          const res = await fetch(fetchUrl);
          const text = await res.text();
          const parser = new DOMParser();
          const markup = parser.parseFromString(text, 'text/html');
          const element = markup.documentElement.querySelector(`[id="notification-product-preview-${productHandle}"]`);
          return element;
        } catch (error) {}
      };
      const handleClick = e => {
        const closeBtn = e.target.closest(selectors$6.closeBtn);
        const productForm = e.target.closest(selectors$6.productForm);
        const sizeSelector = e.target.closest(selectors$6.sizeSelector);
        const bg = e.target.closest(selectors$6.bg);
        if (sizeSelector) {
          return;
        }
        if (closeBtn || bg) {
          closePopUp();
          return;
        }
        if (productForm) {
          e.preventDefault();
          handleAddToCart(productForm);
        }
      };
      const handleFormChange = e => {
        e.preventDefault();
        if (e.target.dataset.availability == 'false') {
          closePopUp();
          dispatchEvent$3(window, events$5.TOGGLE_BIS, {
            variantId: e.target.value
          });
          return;
        } else {
          const productForm = e.target.closest(selectors$6.productForm);
          handleAddToCart(productForm);
        }
      };
      const getTouches = e => {
        return e.touches || e.originalEvent.touches;
      };
      const handleTouchStart = e => {
        if (!isOpen$1) return;
        const firstTouch = getTouches(e)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
      };
      const handleTouchMove = e => {
        if (!xDown || !yDown || !isOpen$1) {
          return;
        }
        var xUp = e.touches[0].clientX;
        var yUp = e.touches[0].clientY;
        var xDiff = xDown - xUp;
        var yDiff = yDown - yUp;
        if (Math.abs(xDiff) < Math.abs(yDiff)) {
          if (yDiff > 0) {
            return;
          } else {
            closePopUp();
          }
        }
        xDown = null;
        yDown = null;
      };
      init();
      return () => {
        window.removeEventListener(events$5.CART_UPDATED, handleCartUpdated);
        window.removeEventListener(events$5.TRIGGER_NOTIFICATION_LAYOUT, toggleLayout);
        document.removeEventListener('touchstart', handleTouchStart, false);
        document.removeEventListener('touchmove', handleTouchMove, false);
        cartNotification.removeEventListener('click', handleClick);
        if (cartNotification.querySelector(selectors$6.productForm)) cartNotification.querySelector(selectors$6.productForm)?.removeEventListener('input', handleFormChange);
      };
    };

    var fragmentCartNotification$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentCartNotification
    });

    const events$4 = window.PoleneLibs.Events.default;
    const {
      getElementByRef: getElementByRef$7
    } = window.PoleneLibs.Refs;
    const classes$8 = {
      visible: 'is-visible',
      constrast: 'has-contrast'
    };
    let type = null;
    let isTouchDevice = !document.getElementsByTagName('html')[0].classList.contains('no-touch');
    var fragmentCursor = () => {
      const {
        cursor
      } = getElementByRef$7('cursor');
      if (!cursor || isTouchDevice) return;
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        window.addEventListener(events$4.CHANGE_CURSOR, handleChangeCursor);
        window.addEventListener('mousemove', handleMouseMove);
      };
      const resetCursor = () => {
        document.body.style.cursor = 'auto';
        cursor.classList.remove(classes$8.visible);
      };
      const handleMouseMove = e => {
        const bounds = cursor.getBoundingClientRect();
        const cursorX = e.clientX - bounds.width / 2;
        const cursorY = e.clientY - bounds.height / 2;
        cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
      };
      const handleChangeCursor = e => {
        document.body.style.cursor = 'none';
        type = e.detail.type;
        if (type === 'default') {
          resetCursor();
          return;
        }
        if (e.detail.contrast) {
          cursor.classList.add(classes$8.constrast);
        } else {
          cursor.classList.remove(classes$8.constrast);
        }
        cursor.classList.add(classes$8.visible);
        cursor.dataset.type = e.detail.type;
      };
      init();
      return () => {
        window.removeEventListener(events$4.CHANGE_CURSOR, handleChangeCursor);
        window.removeEventListener('mousemove', handleMouseMove);
        document.body.style.cursor = 'auto';
      };
    };

    var fragmentCursor$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentCursor
    });

    const events$3 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$2
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$6,
      getRefs: getRefs$8
    } = window.PoleneLibs.Refs;
    const selectors$5 = {
      lineItem: '.js-line-item',
      removeBtn: '.js-remove-btn',
      decrementBtn: '.js-decrement-btn',
      incrementBtn: '.js-increment-btn',
      lineItemCounter: '.js-line-item-counter'
    };
    const classes$7 = {
      hidden: 'is-hidden',
      open: 'is-open',
      loaded: 'loaded'
    };
    var fragmentLineItemsList = () => {
      const {
        cart
      } = getElementByRef$6(['cart']);
      if (!cart) return;
      const cartRefs = getRefs$8(cart, true);
      const init = () => {
        if (cartRefs.current.lineItems) {
          const lineItems = Array.isArray(cartRefs.current.lineItems) ? cartRefs.current.lineItems : [cartRefs.current.lineItems];
          lineItems.forEach(lineItem => {
            const image = lineItem.getElementsByTagName('img')[0];
            image.classList.add(classes$7.loaded);
            lineItem.addEventListener('click', handleItemClick);
          });
        }
        if (cartRefs.current.sizeSelect) {
          const selectElements = Array.isArray(cartRefs.current.sizeSelect) ? cartRefs.current.sizeSelect : [cartRefs.current.sizeSelect];
          selectElements.forEach(selectEl => {
            initSizeSelect(selectEl, selectElements);
          });
        }
      };
      const initSizeSelect = (selectEl, selectElements) => {
        const {
          select,
          options
        } = getRefs$8(selectEl);
        let selected, container, item;
        selected = document.createElement('div');
        selected.setAttribute('class', `p-select__selected ts-label-m`);
        selected.innerHTML = options[select.selectedIndex].innerHTML;
        container = document.createElement('div');
        container.setAttribute('class', 'p-select__item-list');
        container.classList.add(classes$7.hidden);
        const handleLineItemClick = e => {
          e.preventDefault();
          const {
            selectedVariantId,
            currentVariantId,
            currentQuantity
          } = e.target.dataset;
          const updates = {
            [currentVariantId]: 0,
            [selectedVariantId]: currentQuantity
          };
          updateCart(updates);
        };
        const handleToggleList = () => {
          selectElements.forEach(select => {
            if (select === selectEl) return;
            select.querySelector('.p-select__item-list').classList.add(classes$7.hidden);
            select.classList.remove(classes$7.open);
          });
          container.classList.toggle(classes$7.hidden);
          selectEl.classList.toggle(classes$7.open);
        };
        options.forEach((option, i) => {
          if (i === 0) return;
          let quantity = 0;
          const lineItem = selectEl.closest(selectors$5.lineItem);
          if (lineItem) {
            quantity = lineItem.dataset.quantity;
          }
          const currentVariantId = option.dataset.variantId;
          const selectedVariantId = option.value;
          const {
            available
          } = option.dataset;
          item = document.createElement(available === 'true' ? 'a' : 'button');
          item.dataset.currentVariantId = currentVariantId;
          item.dataset.selectedVariantId = selectedVariantId;
          item.dataset.currentQuantity = quantity.toString();
          item.dataset.productId = currentVariantId;
          item.setAttribute('class', 'p-select__item ts-label-s');
          item.innerHTML = option.innerHTML;
          if (available === 'true') {
            item.setAttribute('href', `/cart/update?updates[${currentVariantId}]=0&updates[${selectedVariantId}]=${quantity}`);
            item.addEventListener('click', handleLineItemClick);
          } else {
            item.textContent += ' - ' + window.translations?.notify_me;
            item.classList.add('is-disabled');
            item.setAttribute('type', 'button');
          }
          container.appendChild(item);
        });
        selectEl.appendChild(selected);
        selectEl.appendChild(container);
        selected.addEventListener('click', handleToggleList);
      };
      const handleItemClick = e => {
        if (!e.target || !(e.target instanceof HTMLElement)) return;
        const selectOption = e.target.closest('.p-select__item');
        const lineItem = e.target.closest(selectors$5.lineItem);
        const removeBtn = e.target.querySelector(selectors$5.removeBtn);
        const decrementBtn = e.target.closest(selectors$5.decrementBtn);
        const incrementBtn = e.target.closest(selectors$5.incrementBtn);
        if (!lineItem) return;
        const {
          id,
          quantity
        } = lineItem.dataset;
        if (selectOption && selectOption.tagName === 'BUTTON') {
          const {
            selectedVariantId
          } = selectOption.dataset;
          dispatchEvent$2(window, events$3.TOGGLE_BIS, {
            variantId: selectedVariantId
          });
          if (selectOption.parentNode instanceof HTMLElement) {
            selectOption.parentNode.classList.toggle(classes$7.hidden);
          }
        }
        if (removeBtn) {
          e.preventDefault();
          lineItem.remove();
          handleUpdateCart(id, 0);
        }
        if ((decrementBtn || incrementBtn) && quantity) {
          const newQuantity = parseInt(quantity) + (decrementBtn ? -1 : 1);
          handleUpdateCart(id, newQuantity);
        }
      };
      const maybeDisableIncrementButtons = async (id, quantity) => {
        const lineItem = document.body.querySelector(`${selectors$5.lineItem}[data-id="${id}"]`);
        if (!lineItem) return;
        const incrementButton = lineItem.querySelector(selectors$5.incrementBtn);
        const lineItemCounter = lineItem.querySelector(selectors$5.lineItemCounter);
        const lineItemInventory = Number(lineItemCounter?.getAttribute('max'));
        const isDisabled = !!(lineItemInventory && lineItemInventory <= quantity);
        incrementButton?.toggleAttribute('disabled', isDisabled);
      };
      const handleUpdateCart = async (id, quantity) => {
        await changeCart(id, quantity);
        maybeDisableIncrementButtons(id, quantity);
      };
      const reInit = () => {
        setTimeout(init);
      };
      init();
      window.addEventListener(events$3.CART_DOM_UPDATED, reInit);
      return () => {
        window.removeEventListener(events$3.CART_DOM_UPDATED, reInit);
        if (cartRefs.current.lineItems) {
          const lineItems = Array.isArray(cartRefs.current.lineItems) ? cartRefs.current.lineItems : [cartRefs.current.lineItems];
          lineItems.forEach(lineItem => {
            lineItem.removeEventListener('click', handleItemClick);
          });
        }
      };
    };

    var fragmentLineItemsList$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentLineItemsList
    });

    const {
      getElementByRef: getElementByRef$5,
      getRefs: getRefs$7
    } = window.PoleneLibs.Refs;
    const {
      storeLanguage
    } = window.PoleneLibs.ConstantsDate;
    var fragmentNewsletterSignup = () => {
      const {
        newsletterSignup
      } = getElementByRef$5('newsletter-signup');
      if (!newsletterSignup) return;
      const {
        signupForm,
        formInput,
        messageContainer
      } = getRefs$7(newsletterSignup);
      const {
        messageSuccess,
        messageError,
        messageAlreadySubscribed,
        messageNotValidEmail
      } = signupForm.dataset;
      const inputs = formInput ? Array.isArray(formInput) ? [...formInput] : [formInput] : [];
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        signupForm.addEventListener('submit', handleSubmit);
      };
      const handleSubmit = async e => {
        e.preventDefault();
        if (inputs.length === 0) return;
        if ([...inputs].some(input => !validateEmail(input.value))) {
          messageContainer.innerHTML = '<p class="ts-error"> ' + messageNotValidEmail + '</p>';
          return;
        }
        const formData = new FormData();
        formData.set('email', inputs[0].value);
        formData.set('locale', storeLanguage);
        try {
          const response = await fetch(`${API_PROXY.MARKETING_SUBSCRIBE}`, {
            method: 'POST',
            body: formData
          });
          handleResponse(response);
        } catch {
          messageContainer.innerHTML = '<p class="ts-error">' + messageError + '</p>';
        }
      };
      const handleResponse = async res => {
        if (res.status === 200) messageContainer.innerHTML = '<p>' + messageSuccess + '</p>';else if (res.status === 409) messageContainer.innerHTML = '<p>' + messageAlreadySubscribed + '</p>';else messageContainer.innerHTML = '<p class="ts-error">' + messageError + '</p>';
        inputs.forEach(input => {
          input.value = '';
        });
      };
      init();
      return () => {
        signupForm.removeEventListener('submit', handleSubmit);
      };
    };

    var fragmentNewsletterSignup$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentNewsletterSignup
    });

    const {
      preorderInputTemplate
    } = window.PoleneLibs.ElementTemplates;
    const events$2 = window.PoleneLibs.Events.default;
    const {
      envelope
    } = window.PoleneLibs.SvgTemplates;
    const {
      dispatchEvent: dispatchEvent$1
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$4,
      getElementsByRef: getElementsByRef$4,
      getRefs: getRefs$6
    } = window.PoleneLibs.Refs;
    const classes$6 = {
      hidden: 'is-hidden',
      open: 'is-open',
      disabled: 'is-disabled',
      preorder: 'is-preorder'
    };
    const selectors$4 = {
      option: '.js-option'
    };
    var fragmentOptionSelect = () => {
      const ref = getElementByRef$4(['grid']);
      const {
        customSelect,
        productDetails,
        searchResults
      } = getElementsByRef$4(['custom-select', 'product-details', 'search-results']);
      if (!ref.grid && !customSelect) return;
      let instances = [];
      const refs = getRefs$6(ref.grid, true);
      const initSelects = () => {
        setTimeout(() => {
          const select = Array.isArray(customSelect) ? [...customSelect] : [customSelect];
          const selectElements = refs && refs.current && Array.isArray(refs.current.customSelect) ? [...refs.current.customSelect] : select;
          selectElements.forEach(selectEl => {
            const selectInstance = initSelect(selectEl);
            if (selectInstance) instances.push(selectInstance);
          });
        });
      };
      const initSelect = selectEl => {
        const {
          select,
          options,
          arrowIcon
        } = getRefs$6(selectEl);
        if (!select) return;
        let selected, container, item;
        selected = document.createElement('div');
        selected.setAttribute('class', `p-select__selected ts-label-s`);
        selected.innerHTML = options[select.selectedIndex].innerHTML;
        const buyBar = document.querySelector('.buy-bar__btn-label-text');
        if (buyBar) buyBar.innerHTML = window.translations?.preorder || buyBar.innerHTML;
        container = document.createElement('div');
        container.setAttribute('class', 'p-select__item-list');
        container.classList.add(classes$6.hidden);
        const handleItemClick = e => {
          const optionEl = e.target.closest(selectors$4.option);
          const optionValue = optionEl.getElementsByClassName('option')[0].innerHTML;
          let selectedIndex;
          options.forEach((option, i) => {
            if (option.innerHTML === optionValue) {
              selectedIndex = i;
            }
          });
          if (optionEl.classList.contains(classes$6.disabled)) {
            e.preventDefault();
            handleToggleList(e);
            dispatchEvent$1(window, events$2.TOGGLE_BIS, {
              variantId: options[selectedIndex].value
            });
            return;
          }
          select.selectedIndex = selectedIndex;
          if (selectEl.nextElementSibling.querySelector('input#pre-order') !== null) {
            selectEl.nextElementSibling.querySelector('input#pre-order').remove();
            selectEl.nextElementSibling.querySelector('input#pre-order-tag').remove();
            selectEl.nextElementSibling.querySelector('input#pre-order-date').remove();
          }
          if (selectEl.nextElementSibling.parentElement.querySelector('div.preorder-description') !== null) {
            selectEl.nextElementSibling.parentElement.querySelector('div.preorder-description').remove();
          }
          if (optionEl.classList.contains(classes$6.preorder)) {
            const preOrderInputProperty = select[selectedIndex].dataset.pol;
            const preOrderInputValue = select[selectedIndex].dataset.pofd;
            const preOrderDate = select[selectedIndex].dataset.pod;
            selectEl.nextElementSibling.dataset.state = 'preorder';
            let input = preorderInputTemplate(preOrderInputProperty, preOrderInputValue, preOrderDate);
            selectEl.nextElementSibling.innerHTML += input;
            selectEl.nextElementSibling.parentElement.insertAdjacentHTML('beforeend', `<div class="preorder-description"> ${preOrderInputValue} </div>`);
          } else {
            selectEl.nextElementSibling.dataset.state = 'default';
          }
          options.forEach((option, i) => {
            if (option.innerHTML === e.target.innerHTML) {
              select.selectedIndex = i;
            }
          });
          selected.innerHTML = e.target.innerHTML;
          handleToggleList(e);
        };
        const handleToggleList = e => {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          container.classList.toggle(classes$6.hidden);
          selectEl.classList.toggle(classes$6.open);
        };
        options.forEach((option, i) => {
          if (i === 0) return;
          let optionInner = '';
          let notifyLabel = option.dataset.notifyLabel;
          let preorderLabel = option.dataset.pol;
          item = document.createElement('div');
          item.addEventListener('click', handleItemClick);
          item.setAttribute('class', 'p-select__item js-option ts-label-s');
          optionInner = `<span class="option">${option.innerHTML}</span>`;
          if (option.dataset.availability === 'false') {
            item.setAttribute('disabled', true);
            item.classList.add('is-disabled');
            optionInner = `<span class="option">${option.innerHTML}</span>
          <div class="option-message">
            <span>${notifyLabel}</span>
           ${envelope}
        </div>`;
          }
          if (option.dataset.availability === 'true' && 'pod' in option.dataset) {
            item.setAttribute('preorder', true);
            item.classList.add('is-preorder');
            optionInner = `<span class="option">${option.innerHTML}</span>
          <div class="option-message">
            <span>${preorderLabel}</span>
        </div>`;
          }
          item.innerHTML = optionInner;
          container.appendChild(item);
        });
        selectEl.insertBefore(selected, arrowIcon);
        selectEl.appendChild(container);
        selected.addEventListener('click', handleToggleList);
        return () => {
          selected.removeEventListener('click', handleToggleList);
        };
      };
      if (productDetails || searchResults) {
        initSelects();
      }
      window.addEventListener(events$2.PRODUCT_CARD_RENDERED, initSelects);
      return () => {
        instances.forEach(teardown => teardown());
      };
    };

    var fragmentOptionSelect$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentOptionSelect
    });

    const {
      breakpoints: breakpoints$3
    } = window.PoleneLibs.Breakpoints;
    const {
      getElementByRef: getElementByRef$3,
      getRefs: getRefs$5
    } = window.PoleneLibs.Refs;
    const selectors$3 = {
      item: '.js-item'
    };
    const classes$5 = {
      active: 'is-active',
      visible: 'is-visible'
    };
    var fragmentRevealableItems = () => {
      const {
        revealableItems
      } = getElementByRef$3('revealable-items');
      if (!revealableItems) return;
      const {
        contentContainer,
        titles,
        sliderTitles,
        descriptions
      } = getRefs$5(revealableItems);
      const init = () => {
        setContainerHeight(descriptions[0]);
      };
      const setContainerHeight = el => {
        contentContainer.style.setProperty('--el-height', el.scrollHeight + 'px');
      };
      const handleClick = e => {
        const isMobile = window.innerWidth < breakpoints$3.md;
        const item = e.target.closest(selectors$3.item);
        const currentIndex = item.dataset.index;
        const currentDescription = descriptions.find(description => description.dataset.index === currentIndex);
        let activeTopic;
        if (isMobile) {
          const {
            sliderTitles: activeTitle
          } = getRefs$5(item);
          sliderTitles.forEach(title => {
            title.classList.remove(classes$5.active);
          });
          activeTopic = activeTitle;
        } else {
          const {
            titles: activeTitle
          } = getRefs$5(item);
          titles.forEach(title => {
            title.classList.remove(classes$5.active);
          });
          activeTopic = activeTitle;
        }
        setContainerHeight(currentDescription);
        activeTopic.classList.add(classes$5.active);
        descriptions.forEach(description => {
          if (description == currentDescription) {
            description.classList.add(classes$5.visible);
          } else {
            description.classList.remove(classes$5.visible);
          }
        });
      };
      init();
      revealableItems.addEventListener('click', handleClick);
      return () => {
        revealableItems.removeEventListener('click', handleClick);
      };
    };

    var fragmentRevealableItems$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentRevealableItems
    });

    const {
      getElementsByRef: getElementsByRef$3
    } = window.PoleneLibs.Refs;
    const scrollLock$2 = window.PoleneLibs.ScrollLock.default;
    const classes$4 = {
      open: 'is-open',
      menuOpen: 'menu-open'
    };
    let isOpen = false;
    const update = ref => {
      if (!ref.searchOverlay || !ref.searchInput || !ref.siteHeader || !ref.menu || !ref.searchTrigger) return;
      const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
      if (Array.isArray(ref.searchOverlay)) return;
      ref.searchOverlay.classList.toggle(classes$4.open, isOpen);
      elements.forEach(element => {
        element.classList.toggle('is-active', isOpen);
      });
      scrollLock$2(isOpen);
      if (isOpen && !Array.isArray(ref.searchInput) && !Array.isArray(ref.siteHeader) && !Array.isArray(ref.menu)) {
        ref.searchInput.focus();
        ref.searchInput.select();
        ref.siteHeader.style.backgroundColor = 'hsl(var(--white))';
        ref.menu.classList.remove(classes$4.open);
        ref.siteHeader.classList.remove(classes$4.menuOpen);
        document.body.classList.add('search-open');
      } else if (!Array.isArray(ref.siteHeader)) {
        ref.siteHeader.style.removeProperty('background-color');
        document.body.classList.remove('search-open');
      }
    };
    const setSearchOverlayOpenState = (ref, doOpen) => {
      if (doOpen === undefined) {
        isOpen = !isOpen;
      } else {
        isOpen = doOpen;
      }
      update(ref);
    };
    var fragmentSearchTrigger = () => {
      const ref = getElementsByRef$3(['search-trigger', 'search-overlay', 'search-input', 'site-header', 'menu']);
      if (!ref.searchTrigger) return;
      const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
      const handleClick = () => setSearchOverlayOpenState(ref);
      const handleKeypress = e => {
        if (e.key !== 'Escape') return;
        setSearchOverlayOpenState(ref, false);
      };
      update(ref);
      const teardowns = elements.map(element => {
        element.addEventListener('click', handleClick);
        return () => element.removeEventListener('click', handleClick);
      });
      window.addEventListener('keydown', handleKeypress);
      return () => {
        teardowns.forEach(teardown => teardown());
        window.removeEventListener('keydown', handleKeypress);
        setSearchOverlayOpenState(ref, false);
      };
    };

    var fragmentSearchTrigger$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSearchTrigger,
        setSearchOverlayOpenState: setSearchOverlayOpenState
    });

    const {
      getElementByRef: getElementByRef$2,
      getRefs: getRefs$4
    } = window.PoleneLibs.Refs;
    const scrollLock$1 = window.PoleneLibs.ScrollLock.default;
    const selectors$2 = {
      navItem: '.js-nav-item'
    };
    const classes$3 = {
      hasChildList: 'has-active-child',
      subMenuOpen: 'open-sub-menu',
      open: 'is-open',
      current: 'is-current'
    };
    var fragmentSubMenu = () => {
      const {
        subMenu,
        subMenuClose
      } = getElementByRef$2(['sub-menu', 'sub-menu-close']);
      if (!subMenu || !subMenuClose) return;
      const {
        activeMenus
      } = getRefs$4(subMenu);
      const activeItems = activeMenus ? [...activeMenus] : [];
      const init = () => {
        subMenu.addEventListener('click', handleClick);
        window.addEventListener('resize', closeMenu);
        if (subMenuClose) {
          subMenuClose.addEventListener('click', handleClose);
        }
      };
      const handleClose = () => {
        closeMenu();
      };
      const handleClick = e => {
        e.preventDefault();
        const subMenu = activeItems.length ? activeItems[activeItems.length - 1].parentNode : null;
        const navItem = e.target.closest(selectors$2.navItem);
        if (navItem && !navItem.classList.contains(classes$3.current) && !navItem.classList.contains(classes$3.hasChildList)) {
          const links = navItem.getElementsByTagName('a');
          const url = links[0].getAttribute('href');
          window.location.href = url;
          closeMenu();
        }
        if (!subMenu) return;
        if (subMenu.classList.contains(classes$3.open)) {
          subMenu.classList.remove(classes$3.open);
          document.body.classList.remove(classes$3.subMenuOpen);
          scrollLock$1(false);
        } else {
          subMenu.classList.add(classes$3.open);
          document.body.classList.add(classes$3.subMenuOpen);
          scrollLock$1(true);
        }
      };
      const closeMenu = () => {
        if (activeItems.length > 0) {
          activeItems.forEach(item => {
            item.parentNode.classList.remove(classes$3.open);
          });
        }
        document.body.classList.remove(classes$3.subMenuOpen);
        scrollLock$1(false);
      };
      init();
      return () => {
        subMenu.removeEventListener('click', handleClick);
        window.removeEventListener('resize', closeMenu);
        if (subMenuClose) {
          subMenuClose.removeEventListener('click', handleClose);
        }
      };
    };

    var fragmentSubMenu$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSubMenu
    });

    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef: getElementsByRef$2,
      getRefs: getRefs$3
    } = window.PoleneLibs.Refs;
    const zeroPad = x => x.toString().padStart(2, '0');
    const parseBool = str => str && str === 'true' ? true : false;
    const parseTime = time => {
      const minutes = Math.floor(time / 60);
      const seconds = Math.round(time - minutes * 60);
      return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
    };
    var fragmentVideo = () => {
      const {
        video,
        videoNative
      } = getElementsByRef$2(['video', 'video-native']);
      if (!video) return;
      const videos = Array.isArray(video) ? [...video] : [video];
      const handleIntersection = entries => {
        entries.forEach(entry => {
          const {
            isIntersecting,
            target
          } = entry;
          if (isIntersecting) {
            target.src = target.dataset.src;
            observer.unobserve(target);
          }
        });
      };
      const observer = intersection(null, handleIntersection, {
        rootMargin: `500px 0px 500px 0px`,
        threshold: [0]
      });
      if (videoNative) {
        const videos = videoNative ? Array.isArray(videoNative) ? [...videoNative] : [videoNative] : [];
        videos.forEach(videoNative => {
          observer.observe(videoNative);
        });
      }
      videos.map(video => {
        const refs = getRefs$3(video);
        if (refs.vimeoPlayer) {
          const options = {
            ...(refs.vimeoPlayer.dataset.vimeoUrl.includes('vimeo.com') ? {
              url: refs.vimeoPlayer.dataset.vimeoUrl
            } : {
              id: refs.vimeoPlayer.dataset.vimeoUrl
            }),
            byline: false,
            portrait: false,
            title: false,
            responsive: true
          };
          const player = new Vimeo.Player(refs.vimeoPlayer.id, options);
          let duration = 0;
          player.on('timeupdate', e => {
            duration = e.duration;
            if (refs.currentTime) refs.currentTime.textContent = parseTime(e.duration * e.percent);
            if (refs.duration) refs.duration.textContent = parseTime(e.duration);
            if (refs.timeline) {
              refs.timeline.value = e.percent;
              refs.timeline.style.setProperty('--progress', e.percent);
            }
          });
          player.on('volumechange', e => {
            if (refs.volume) refs.volume.value = e.volume;
            if (volume) volume.style.setProperty('--progress', e.volume);
          });
          player.on('loaded', async () => {
            const initVolume = await player.getVolume();
            if (refs.play) refs.play.textContent = parseBool(refs.vimeoPlayer.dataset.vimeoAutoplay) ? 'Pause' : 'Play';
            if (refs.volume) {
              refs.volume.value = initVolume;
              refs.volume.style.setProperty('--progress', initVolume);
            }
          });
          const handlePlay = async ({
            target
          }) => {
            if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
            if (await player.getPaused()) {
              player.play();
              if (refs.play) refs.play.textContent = 'Pause';
            } else {
              player.pause();
              if (refs.play) refs.play.textContent = 'Play';
            }
          };
          const handleSeek = e => {
            player.setCurrentTime(parseFloat(e.target.value) * duration);
            if (refs.timeline) refs.timeline.style.setProperty('--progress', parseFloat(e.target.value));
          };
          const handleVolume = e => {
            player.setVolume(parseFloat(e.target.value));
            if (refs.volume) {
              refs.volume.style.setProperty('--progress', parseFloat(e.target.value));
            }
          };
          const handleMute = async () => {
            const volume = await player.getVolume();
            if (refs.mute) {
              if (volume > 0.5) {
                player.setVolume(0);
                refs.mute.dataset.state = 'unmute';
              } else {
                player.setVolume(1);
                refs.mute.dataset.state = 'mute';
              }
            }
          };
          refs.play?.addEventListener('click', handlePlay);
          refs.vimeoPlayer?.addEventListener('click', handlePlay);
          refs.timeline?.addEventListener('input', handleSeek);
          refs.volume?.addEventListener('input', handleVolume);
          refs.mute?.addEventListener('input', handleMute);
        }
        if (refs.videoNative) {
          let isPlaying = parseBool(refs.videoNative.getAttribute('muted')) && parseBool(refs.videoNative.getAttribute('autoplay'));
          let progress = 0;
          const updateUI = () => {
            progress = refs.videoNative.currentTime / refs.videoNative.duration;
            if (refs.timeline) {
              refs.timeline.style.setProperty('--progress', parseFloat(progress.toString()));
              refs.timeline.value = parseFloat(progress.toString());
            }
            if (refs.volume) {
              refs.volume.value = refs.videoNative.muted ? 0 : refs.videoNative.volume;
              refs.volume.style.setProperty('--progress', parseFloat(refs.volume.value));
            }
            if (refs.currentTime) {
              refs.currentTime.textContent = parseTime(refs.videoNative.currentTime);
            }
            if (refs.duration) {
              refs.duration.textContent = parseTime(refs.videoNative.duration);
            }
            if (refs.mute) {
              if (refs.videoNative.muted) {
                refs.mute.dataset.state = 'unmute';
              } else {
                refs.mute.dataset.state = 'mute';
              }
            }
            if (refs.play) {
              if (isPlaying) {
                refs.play.textContent = 'Pause';
              } else {
                refs.play.textContent = 'Play';
              }
            }
            if (isPlaying) requestAnimationFrame(updateUI);
          };
          updateUI();
          const handlePlay = ({
            target
          }) => {
            if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
            isPlaying = !isPlaying;
            if (isPlaying) {
              refs.videoNative.play();
            } else {
              refs.videoNative.pause();
            }
            updateUI();
          };
          const handleSeek = e => {
            refs.videoNative.currentTime = e.target.value * refs.videoNative.duration;
            updateUI();
          };
          const handleVolume = e => {
            refs.videoNative.muted = false;
            refs.videoNative.volume = e.target.value;
            updateUI();
          };
          const handleMute = () => {
            const muted = parseBool(refs.videoNative.getAttribute('muted'));
            refs.videoNative.setAttribute('muted', !muted);
            refs.videoNative.muted = !muted;
            updateUI();
          };
          if (refs.play) {
            video?.addEventListener('click', handlePlay);
          }
          refs.volume?.addEventListener('input', handleVolume);
          refs.mute?.addEventListener('click', handleMute);
          refs.timeline?.addEventListener('input', handleSeek);
        }
      });
    };

    var fragmentVideo$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentVideo
    });

    const camelCase = s => s.replace(/-./g, x => x[1].toUpperCase());
    const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
    function groupByRef(element, result, onlyFirst = false) {
      const ref = element.getAttribute('data-ref');
      if (!ref) return;
      const refs = ref.split(' ').map(camelCase);
      refs.forEach(capitalizedRef => {
        if (onlyFirst) {
          if (!result[capitalizedRef]) {
            result[capitalizedRef] = element;
          }
        } else {
          if (result[capitalizedRef]) {
            if (Array.isArray(result[capitalizedRef])) {
              result[capitalizedRef].push(element);
            } else {
              result[capitalizedRef] = [result[capitalizedRef], element];
            }
          } else {
            result[capitalizedRef] = element;
          }
        }
      });
    }
    const getElementsByRef$1 = (refs, target) => {
      const root = target instanceof HTMLElement ? target : document.body;
      const result = {};
      const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref*="${ref}"]`).join(',') : `[data-ref*="${refs}"]`;
      const elements = root.querySelectorAll(selector);
      elements.forEach(element => groupByRef(element, result));
      return result;
    };
    const getRefs$2 = (target = document.body, watch) => {
      const root = typeof target === 'string' ? document.querySelector(`[data-namespace="${target}"]`) : target;
      if (!root) {
        return;
      }
      const name = root?.getAttribute('data-namespace');
      return watch ? _watched(root, name, watch) : _refs(root, name, true);
    };
    function _refs(root, name, includeRoot) {
      const attribute = name ? `data-ref-${name}` : 'data-ref';
      return [...root.querySelectorAll(`[${attribute}]`)].reduce((refs, el) => {
        const dataset = name ? `ref${capitalize(name)}` : 'ref';
        return {
          ...(includeRoot && {
            root
          }),
          ...refs,
          ...(camelCase(el.dataset[dataset]) || 'item').split(' ').reduce((acc, newRef) => ({
            ...acc,
            [newRef]: refs[newRef] ? [refs[newRef], el].flat() : el
          }), {})
        };
      }, {});
    }
    function _watched(r, n, onChange) {
      const observer = new MutationObserver(() => {
        ref.current = _refs(r, n);
        typeof onChange === 'function' && onChange();
      });
      observer.observe(r, {
        childList: true,
        subtree: true
      });
      const ref = {
        root: r,
        current: _refs(r, n),
        unwatch: observer.disconnect.bind(observer)
      };
      return ref;
    }
    getRefs$2();

    var imageLoaded = () => {
      const {
        image,
        video
      } = getElementsByRef$1(['image', 'video']);
      const images = image ? Array.isArray(image) ? image : [image] : [];
      const videos = video ? Array.isArray(video) ? video : [video] : [];
      const handleImageLoad = ({
        target
      }) => {
        target.classList.add('loaded');
      };
      images.forEach(image => {
        if (image.complete) {
          handleImageLoad({
            target: image
          });
        } else {
          image.addEventListener('load', handleImageLoad, {
            once: true
          });
        }
      });
      videos.forEach(video => {
        video.addEventListener('canplaythrough', handleImageLoad);
        setTimeout(() => {
          handleImageLoad({
            target: video
          });
        }, 1000);
      });
    };

    var imageLoaded$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: imageLoaded
    });

    const breakpoints$2 = {
      'sm': 600,
      'md': 1024,
      'lg': 1200,
      'xl': 1440,
      'page-max': 1660
    };

    const progress = (() => {
      const multiplier = 0.1;
      let instances = [];
      window.ins = instances;
      let ticking = false;
      let raf = null;
      const start = () => {
        ticking = true;
        animate();
      };
      const pause = () => {
        ticking = false;
        if (raf) cancelAnimationFrame(raf);
      };
      const destroy = () => {
        pause();
        instances = [];
      };
      const isAnimating = () => {
        return ticking;
      };
      const add = ({
        element,
        value
      }) => {
        const valueAsFloat = value;
        const bounds = element.getBoundingClientRect();
        const startFromZero = bounds.y + bounds.height + scrollY >= 0 && bounds.y + scrollY < innerHeight ? true : false;
        const initialProgressInScreen = Math.max((innerHeight - bounds.y - scrollY) / (innerHeight + bounds.height), 0);
        let startValue = 0;
        let endValue = 0;
        if (startFromZero) {
          startValue = 0;
        } else {
          startValue = valueAsFloat * -0.5;
        }
        endValue = valueAsFloat * 0.5;
        const instance = {
          element,
          startValue,
          endValue,
          range: endValue - startValue,
          currentValue: null,
          initialProgressInScreen,
          isInitialized: false
        };
        instances.push(instance);
        if (!ticking) {
          start();
        }
      };
      const animate = () => {
        const {
          innerHeight
        } = window;
        let instancesLength = instances.length;
        let i = instancesLength;
        if (raf) {
          cancelAnimationFrame(raf);
        }
        if (ticking) {
          raf = requestAnimationFrame(animate);
        }
        while (i) {
          i--;
          const instance = instances[i];
          const {
            element,
            startValue,
            endValue,
            initialProgressInScreen,
            isInitialized
          } = instance;
          const bounds = element.getBoundingClientRect();
          let progress = (innerHeight - bounds.y) / (innerHeight + bounds.height);
          let normalizedProgress = (progress - initialProgressInScreen) / (1 - initialProgressInScreen);
          if (normalizedProgress > 1) normalizedProgress = 1;
          if (normalizedProgress < 0) normalizedProgress = 0;
          if (normalizedProgress === 0 && instance.currentValue === startValue) continue;
          if (normalizedProgress >= 1 && instance.currentValue === endValue) continue;
          const targetValue = (endValue - startValue) * normalizedProgress + startValue;
          const delta = targetValue - (instance.currentValue ?? 0);
          const velocity = Math.abs(delta) < 0.1 ? 0 : delta * multiplier;
          instance.currentValue = (instance.currentValue ?? 0) + velocity;
          instance.currentValue = parseFloat(instance.currentValue.toFixed(3));
          if (Math.abs(delta) < 0.1 || !isInitialized) {
            instance.currentValue = parseFloat(targetValue.toFixed(3));
            instance.isInitialized = true;
          }
          const transformString = `translate3d(0, ${instance.currentValue}px,0)`;
          setTransform(element, transformString);
        }
      };
      const setTransform = (element, transform) => {
        element.style.transform = transform;
      };
      return {
        start,
        pause,
        destroy,
        isAnimating,
        add
      };
    })();

    var parallax = () => {
      const ref = getElementsByRef$1(['parallax-el']);
      if (!ref?.parallaxEl) return;
      const parallaxItems = Array.isArray(ref.parallaxEl) ? ref.parallaxEl : [ref.parallaxEl];
      let items = [];
      let isMobile = window.innerWidth < breakpoints$2.md;
      const init = () => {
        window.addEventListener('load', isReady);
      };
      const isReady = () => {
        items = isMobile ? parallaxItems.filter(item => !item.hasAttribute('data-disable-mobile-parallax')) : parallaxItems;
        items.forEach(item => {
          progress.add({
            element: item,
            value: item.dataset.parallax ? parseFloat(item.dataset.parallax) : 0
          });
        });
      };
      init();
      return () => {
        window.removeEventListener('load', isReady);
        progress.destroy();
      };
    };

    var parallax$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: parallax
    });

    const events$1 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    const classes$2 = {
      announcementBarActive: 'announcement-bar-active',
      appear: 'appear'
    };
    var sectionAnnouncementBar = () => {
      const {
        announcementBar,
        siteHeader
      } = getElementByRef$1(['announcement-bar', 'site-header']);
      if (!announcementBar || !siteHeader) return;
      const init = () => {
        document.body.style.setProperty('--header-top-pos', '30px');
        siteHeader.classList.add(classes$2.announcementBarActive);
        announcementBar.classList.add(classes$2.appear);
        dispatchEvent(window, events$1.ANNOUNCEMENT_BAR_RENDERED);
      };
      init();
    };

    var sectionAnnouncementBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionAnnouncementBar
    });

    const {
      breakpoints: breakpoints$1
    } = window.PoleneLibs.Breakpoints;
    const {
      getElementsByRef,
      getRefs: getRefs$1
    } = window.PoleneLibs.Refs;
    const selectors$1 = {
      item: '.js-teaser-item'
    };
    const classes$1 = {
      reveal: 'reveal',
      active: 'is-active'
    };
    var sectionArticleTeaser = () => {
      const {
        articleTeaser
      } = getElementsByRef(['article-teaser']);
      if (!articleTeaser) return;
      const articleTeasers = Array.isArray(articleTeaser) ? articleTeaser : [articleTeaser];
      articleTeasers.forEach(teaser => {
        let interval;
        let currentIdx = 0;
        let lastIdx = 0;
        let mobileIndex = 0;
        let mobileInterval;
        const {
          previewImages,
          items,
          articleTeaserItem
        } = getRefs$1(teaser);
        const init = () => {
          setEventlisteners();
        };
        const setEventlisteners = () => {
          teaser.addEventListener('mouseover', handleMouseOver);
        };
        const handleMouseOver = e => {
          const item = e.target instanceof Element ? e.target.closest(selectors$1.item) : null;
          if (item) {
            const activeIdx = item.dataset.index ? item.dataset.index : 0;
            const links = items ? Array.from(items) : [];
            links.forEach(link => {
              if (link == item) {
                link.classList.add(classes$1.active);
              } else {
                link.classList.remove(classes$1.active);
              }
            });
            if (lastIdx === activeIdx) return;
            lastIdx = activeIdx;
            stopCounter();
            revealImage(previewImages, activeIdx);
            if (item.dataset.imageAmount) {
              const imageAmount = item.dataset.imageAmount;
              const preview = previewImages.find(p => p?.dataset?.index === activeIdx);
              const {
                revealImages
              } = getRefs$1(preview);
              if (revealImages.length) {
                revealImage(revealImages, 0);
                interval = setInterval(() => {
                  if (currentIdx == imageAmount - 1) {
                    currentIdx = 0;
                  } else {
                    currentIdx = currentIdx + 1;
                  }
                  revealImage(revealImages, currentIdx);
                }, 1800);
              }
            }
          }
        };
        const stopCounter = () => {
          clearInterval(interval ?? undefined);
        };
        if (window.innerWidth <= breakpoints$1.md) {
          const updateClasses = () => {
            previewImages.forEach((item, idx) => {
              const reveal = idx === mobileIndex;
              item.classList.toggle('reveal', reveal);
              item.firstElementChild?.classList.add('reveal');
              articleTeaserItem[idx].classList.toggle('reveal', reveal);
            });
          };
          updateClasses();
          mobileInterval = setInterval(() => {
            mobileIndex = (mobileIndex + 1) % previewImages.length;
            updateClasses();
          }, 3200);
        }
        const revealImage = (images, idx) => {
          images.forEach(img => {
            if (img.dataset.index == idx) {
              img.classList.add(classes$1.reveal);
            } else {
              img.classList.remove(classes$1.reveal);
            }
          });
        };
        init();
        return () => {
          teaser.removeEventListener('mouseover', handleMouseOver);
          if (mobileInterval) clearInterval(mobileInterval);
        };
      });
    };

    var sectionArticleTeaser$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionArticleTeaser
    });

    const {
      breakpoints
    } = window.PoleneLibs.Breakpoints;
    const events = window.PoleneLibs.Events.default;
    const scrollLock = window.PoleneLibs.ScrollLock.default;
    const {
      getElementByRef,
      getRefs,
      ref
    } = window.PoleneLibs.Refs;
    const selectors = {
      item: '.js-item',
      menuToggle: '.js-menu-toggle',
      faveCounter: '.js-fave-counter',
      subNavTitle: '.js-sub-nav-title'
    };
    const classes = {
      item: 'js-item',
      menuOpen: 'menu-open',
      scrolled: 'is-scrolled',
      open: 'is-open',
      announcementBarActive: 'announcement-bar-active',
      reveal: 'reveal',
      active: 'is-active'
    };
    const isMobile = () => window.innerWidth < breakpoints.md;
    const isSmall = () => window.innerWidth < breakpoints.sm;
    const isScrolled = () => window.scrollY > (isMobile() ? 0 : 80);
    var sectionHeader = () => {
      const {
        siteHeader,
        closeMenu
      } = getElementByRef(['site-header', 'close-menu']);
      if (!siteHeader || !closeMenu) return;
      const {
        menu,
        menuItem,
        imageLink,
        hoverImg,
        subNavTitle
      } = getRefs(siteHeader);
      const imageLinks = imageLink ? [].concat(imageLink) : [];
      const hoverImages = hoverImg ? [].concat(hoverImg) : [];
      const menuItems = menuItem ? [].concat(menuItem) : [];
      const subNavTitles = subNavTitle ? [].concat(subNavTitle) : [];
      let timer = null;
      let activeDropdown = null;
      let activeContainer = null;
      let containerFocusable = null;
      let triggerElem = null;
      let focusedElem = document.activeElement;
      const init = () => {
        setEventListeners();
        handleScroll();
      };
      const handleResize = () => {
        handleScroll();
      };
      const setEventListeners = () => {
        window.addEventListener('scroll', handleScroll, {
          passive: true
        });
        window.addEventListener('resize', handleResize, {
          passive: true
        });
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener(events.CART_UPDATED, updateCartCount);
        window.addEventListener(events.ANNOUNCEMENT_BAR_RENDERED, setCSSVariables);
        menuItems.forEach(item => {
          if (item.classList.contains(classes.active) && isMobile()) {
            if (item.dataset.level == '3') {
              const firstLevel = item.closest('[data-level="1"]');
              const subNav = item.closest('ul');
              const secondLevel = subNav?.previousElementSibling;
              firstLevel?.setAttribute('aria-expanded', 'true');
              secondLevel && subNav && toggleSubNav(secondLevel, subNav);
            } else {
              item.setAttribute('aria-expanded', 'true');
            }
          }
          if (item.dataset.level === '1' && item.dataset.children && +item.dataset.children > 0) {
            item.addEventListener('mouseenter', handleOpenDropdown);
            item.addEventListener('mouseleave', handleCloseDropdown);
            item.addEventListener('click', handleToggleNextLevel);
          }
          if (item.dataset.level === '2') {
            item.addEventListener('click', handleOpenSubNav);
          }
        });
        subNavTitles.forEach(title => {
          title.addEventListener('click', handleCloseSubNav);
        });
        imageLinks.forEach(link => {
          link.addEventListener('mouseenter', e => handleRevealImage(e, true));
          link.addEventListener('mouseleave', e => handleRevealImage(e, false));
        });
        if (closeMenu) {
          closeMenu.addEventListener('click', handleClose);
        }
        siteHeader?.addEventListener('click', handleClick);
      };
      const handleToggleNextLevel = e => {
        const target = e.target;
        const item = target?.closest(selectors.item);
        const subNavTitle = target?.closest(selectors.subNavTitle);
        if (subNavTitle) return;
        item?.setAttribute('aria-expanded', 'true');
      };
      const handleOpenSubNav = e => {
        const item = e.currentTarget;
        const subNav = item?.nextElementSibling;
        item && subNav && toggleSubNav(item, subNav);
      };
      const toggleSubNav = (item, subNav) => {
        const expanded = subNav.getAttribute('aria-expanded');
        if (expanded === 'false') {
          subNav.style.maxHeight = subNav.scrollHeight + 'px';
          subNav.style.opacity = '1';
          subNav.setAttribute('aria-expanded', 'true');
          item.classList.add(classes.open);
        } else {
          subNav.style.maxHeight = '0px';
          subNav.style.opacity = '0';
          subNav.setAttribute('aria-expanded', 'false');
          item.classList.remove(classes.open);
        }
      };
      const handleCloseSubNav = () => {
        menuItems.forEach(item => {
          item.setAttribute('aria-expanded', 'false');
        });
      };
      const handleOpenDropdown = e => {
        if (!isMobile()) {
          timer && clearTimeout(timer);
          if (activeDropdown && activeDropdown !== e.target) {
            menuItems.forEach(item => {
              item.setAttribute('aria-expanded', 'false');
            });
          }
          activeDropdown = e.target;
          activeDropdown?.setAttribute('aria-expanded', 'true');
          siteHeader?.classList.add(classes.menuOpen);
          document.body.classList.add(classes.menuOpen);
          activeContainer = activeDropdown?.querySelector('div[data-ref="nav-containers"]');
          if (!activeContainer) return;
          containerFocusable = Array.from(activeContainer?.querySelectorAll('a.ts-tertiary-item'));
        }
      };
      const handleCloseDropdown = e => {
        if (!isMobile()) {
          timer && clearTimeout(timer);
          timer = window.setTimeout(() => {
            e.target?.setAttribute('aria-expanded', 'false');
            siteHeader?.classList.remove(classes.menuOpen);
            document.body.classList.remove(classes.menuOpen);
            activeDropdown = null;
          }, 200);
          activeContainer = null;
          containerFocusable = [];
          if (triggerElem) {
            triggerElem.focus();
            triggerElem = null;
          }
        }
      };
      const handleRevealImage = (e, reveal) => {
        hoverImages.forEach(img => {
          if (img.dataset.media === e.target?.dataset.handle) {
            if (reveal) {
              img.classList.add(classes.reveal);
            } else {
              img.classList.remove(classes.reveal);
            }
          }
        });
      };
      const handleClose = () => {
        menu?.classList.remove(classes.open);
        document.body.classList.remove(classes.open);
        siteHeader?.classList.remove(classes.menuOpen);
        document.body.classList.remove(classes.menuOpen);
        scrollLock(false);
      };
      const handleClick = e => {
        const menuTriggered = menu.contains(focusedElem);
        const toggle = e.target?.closest(selectors.menuToggle);
        const isMenuOpen = siteHeader?.classList.contains(classes.menuOpen);
        if (menuTriggered) {
          const event = new KeyboardEvent('keydown', {
            key: 'Enter',
            keyCode: 13,
            code: 'Enter',
            which: 13,
            bubbles: true
          });
          focusedElem?.dispatchEvent(event);
        }
        if (toggle) {
          const header = siteHeader;
          menu?.classList.toggle(classes.open);
          header?.classList.toggle(classes.menuOpen);
          document.body.classList.toggle(classes.open);
          document.body.classList.toggle(classes.menuOpen);
          setSearchOverlayOpenState(ref, false);
          handleColorTheme(!isMenuOpen);
          scrollLock(!isMenuOpen);
        }
      };
      const handleColorTheme = menuOpen => {
        const pageColor = document.body.classList.contains('theme-beige') ? '#EDEAE7' : 'transparent';
        const metaThemeColor = document.querySelector("meta[name='theme-color']");
        if (!metaThemeColor) return;
        if (menuOpen) {
          metaThemeColor.content = '#fff';
        } else {
          metaThemeColor.content = pageColor;
        }
      };
      const handleScroll = () => {
        siteHeader?.classList.toggle(classes.scrolled, isScrolled());
        document.body.classList.toggle(classes.scrolled, isScrolled());
        setCSSVariables();
        setProductDetailsMarginTopCssVariable();
      };
      const handleKeyDown = event => {
        if (event.key === 'Enter') {
          const target = event.target;
          if (target.hasAttribute('aria-expanded')) {
            triggerElem = target;
            handleOpenDropdown(event);
          }
        }
        if (event.key === 'Escape') {
          handleCloseDropdown(event);
          handleCloseSubNav();
        }
        if (event.key === 'Tab') {
          handleTab(event);
        }
      };
      const handleTab = event => {
        setTimeout(() => focusedElem = document.activeElement, 50);
        if (!containerFocusable) return;
        const isReverseTabbing = event.shiftKey;
        const firstElement = containerFocusable[0];
        const lastElement = containerFocusable[containerFocusable.length - 1];
        if (event.target == firstElement && isReverseTabbing) {
          event.preventDefault();
          lastElement.focus();
        }
        if (event.target == lastElement && !isReverseTabbing) {
          event.preventDefault();
          firstElement.focus();
        }
      };
      const calculateTotalHeight = element => {
        if (!element) return 0;
        const rect = element.getBoundingClientRect();
        return Math.floor(rect.height);
      };
      const setCSSVariables = () => {
        const hasAnnouncementBar = siteHeader?.classList.contains(classes.announcementBarActive);
        const {
          height
        } = siteHeader.getBoundingClientRect();
        const translate = !isScrolled() || isSmall() ? 0 : 20;
        const headerHeight = `${height - translate}px`;
        const fullHeight = hasAnnouncementBar ? `${height - translate + 30}px` : `${height - translate}px`;
        const initHeaderHeight = hasAnnouncementBar ? `${height + 30}px` : `${height}px`;
        document.body.style.setProperty('--init-header-height', initHeaderHeight);
        document.body.style.setProperty('--header-height', headerHeight);
        document.body.style.setProperty('--full-header-height', fullHeight);
        document.body.style.setProperty('--full-height', `${window.innerHeight}px`);
      };
      const setProductDetailsMarginTopCssVariable = () => {
        const hasAnnouncementBar = siteHeader?.classList.contains(classes.announcementBarActive);
        const {
          height
        } = siteHeader.getBoundingClientRect();
        const translate = !isScrolled() || isSmall() ? 0 : 20;
        const productInfoHeader = document.querySelector('.product-hero-info__header');
        const productInfoMain = document.querySelector('.product-hero-info__main');
        const productInfoBottom = document.querySelector('.product-hero-info__bottom');
        const totalHeight = calculateTotalHeight(productInfoHeader) + calculateTotalHeight(productInfoMain) + calculateTotalHeight(productInfoBottom);
        document.body.style.setProperty('--product-details-margin-top', `${Math.max(0, totalHeight + 55 + (hasAnnouncementBar ? height - translate + 30 : height - translate) - window.innerHeight)}px`);
      };
      const updateCartCount = () => {
        fetchCart();
      };
      init();
      return () => {
        window.removeEventListener(events.CART_UPDATED, updateCartCount);
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
        siteHeader?.removeEventListener('click', handleClick);
        menuItems.forEach(item => {
          if (item.dataset.level === '1' && item.dataset.children && +item.dataset.children > 0) {
            item.removeEventListener('mouseenter', handleOpenDropdown);
            item.removeEventListener('mouseleave', handleCloseDropdown);
            item.removeEventListener('click', handleToggleNextLevel);
          }
          if (item.dataset.level === '2') {
            item.removeEventListener('click', handleOpenSubNav);
          }
        });
        subNavTitles.forEach(title => {
          title.removeEventListener('click', handleCloseSubNav);
        });
        imageLinks.forEach(link => {
          const handleMouseEnter = e => handleRevealImage(e, true);
          const handleMouseLeave = e => handleRevealImage(e, false);
          link.removeEventListener('mouseenter', handleMouseEnter);
          link.removeEventListener('mouseleave', handleMouseLeave);
        });
        if (closeMenu) {
          closeMenu.removeEventListener('click', handleClose);
        }
      };
    };

    var sectionHeader$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionHeader
    });

})();
